var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "372.12pt",
    height: "372.12pt",
    viewBox: "0 0 372.12 372.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.734375 -5.484375 C -1.660156 -5.429688 -1.570313 -5.398438 -1.46875 -5.390625 C -1.375 -5.378906 -1.277344 -5.394531 -1.1875 -5.4375 C -1.09375 -5.488281 -1.011719 -5.554688 -0.953125 -5.640625 C -0.898438 -5.722656 -0.867188 -5.8125 -0.859375 -5.90625 C -0.847656 -6.007813 -0.863281 -6.109375 -0.90625 -6.203125 C -0.957031 -6.292969 -1.023438 -6.367188 -1.109375 -6.421875 C -1.191406 -6.472656 -1.28125 -6.503906 -1.375 -6.515625 C -1.476563 -6.523438 -1.570313 -6.503906 -1.65625 -6.453125 C -1.746094 -6.410156 -1.820313 -6.347656 -1.875 -6.265625 C -1.925781 -6.191406 -1.957031 -6.101563 -1.96875 -6 C -1.976563 -5.90625 -1.960938 -5.808594 -1.921875 -5.71875 C -1.878906 -5.625 -1.816406 -5.542969 -1.734375 -5.484375 Z M -9.359375 -2.671875 C -10.691406 -2.785156 -11.757813 -3.679688 -12.5625 -5.359375 L -15.8125 -2.25 C -16.277344 -1.789063 -16.882813 -1.554688 -17.625 -1.546875 L -17.703125 -1.5625 C -18.242188 -1.601563 -18.691406 -1.796875 -19.046875 -2.140625 C -19.472656 -2.636719 -19.679688 -3.160156 -19.671875 -3.703125 C -19.679688 -3.773438 -19.679688 -3.847656 -19.671875 -3.921875 C -19.617188 -4.585938 -19.378906 -5.125 -18.953125 -5.53125 L -17.828125 -6.65625 C -16.648438 -7.746094 -16.039063 -8.59375 -16 -9.1875 C -15.988281 -9.269531 -15.984375 -9.34375 -15.984375 -9.40625 L -14.75 -9.3125 C -14.664063 -8.9375 -14.640625 -8.585938 -14.671875 -8.265625 C -14.679688 -8.109375 -14.710938 -7.949219 -14.765625 -7.796875 C -14.898438 -7.367188 -15.65625 -6.523438 -17.03125 -5.265625 C -17.277344 -5.046875 -17.410156 -4.824219 -17.421875 -4.609375 C -17.441406 -4.398438 -17.335938 -4.191406 -17.109375 -3.984375 C -17.035156 -3.898438 -16.949219 -3.851563 -16.859375 -3.84375 C -16.660156 -3.832031 -16.425781 -3.960938 -16.15625 -4.234375 L -12.328125 -7.90625 L -12.296875 -7.953125 C -12.285156 -7.953125 -12.285156 -7.945313 -12.296875 -7.9375 L -12.25 -7.953125 L -12.265625 -7.921875 C -11.710938 -6.921875 -11.199219 -6.339844 -10.734375 -6.1875 C -10.265625 -6.039063 -9.714844 -5.941406 -9.09375 -5.890625 L -3 -5.390625 C -3.082031 -5.617188 -3.113281 -5.851563 -3.09375 -6.09375 C -3.070313 -6.382813 -2.976563 -6.65625 -2.8125 -6.90625 C -2.644531 -7.152344 -2.414063 -7.34375 -2.125 -7.46875 C -1.84375 -7.589844 -1.558594 -7.644531 -1.28125 -7.625 C -0.664063 -7.570313 -0.210938 -7.371094 0.078125 -7.03125 C 0.378906 -6.675781 0.503906 -6.152344 0.453125 -5.46875 C 0.359375 -4.3125 0.0234375 -3.457031 -0.546875 -2.90625 C -1.160156 -2.320313 -2.046875 -2.078125 -3.203125 -2.171875 Z M -9.359375 -2.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -5.34375 -5.625 C -5.289063 -5.933594 -5.160156 -6.21875 -4.953125 -6.46875 C -4.753906 -6.726563 -4.503906 -6.910156 -4.203125 -7.015625 C -3.898438 -7.128906 -3.585938 -7.160156 -3.265625 -7.109375 C -2.960938 -7.054688 -2.679688 -6.925781 -2.421875 -6.71875 C -2.160156 -6.507813 -1.976563 -6.246094 -1.875 -5.9375 C -1.769531 -5.632813 -1.742188 -5.335938 -1.796875 -5.046875 C -1.117188 -5.261719 -0.664063 -6.0625 -0.4375 -7.4375 C -0.3125 -8.214844 -0.367188 -8.921875 -0.609375 -9.546875 C -0.855469 -10.167969 -1.320313 -10.539063 -2 -10.65625 C -2.738281 -10.777344 -3.484375 -10.605469 -4.234375 -10.140625 C -4.992188 -9.671875 -5.789063 -8.355469 -6.625 -6.203125 C -7.457031 -4.046875 -8.554688 -3.082031 -9.921875 -3.3125 C -10.773438 -3.445313 -11.367188 -3.816406 -11.703125 -4.421875 C -12.042969 -5.023438 -12.097656 -6.046875 -11.859375 -7.484375 C -11.734375 -8.253906 -11.308594 -9.109375 -10.59375 -10.046875 C -10.15625 -10.585938 -9.898438 -11.082031 -9.828125 -11.53125 C -9.753906 -11.945313 -10.234375 -12.726563 -11.265625 -13.875 L -9.265625 -15.140625 C -8.347656 -14.046875 -8.007813 -12.757813 -8.25 -11.28125 C -8.371094 -10.519531 -8.722656 -9.757813 -9.296875 -9 C -9.878906 -8.226563 -10.203125 -7.636719 -10.265625 -7.234375 C -10.335938 -6.847656 -10.050781 -6.601563 -9.40625 -6.5 C -8.414063 -6.332031 -7.597656 -7.097656 -6.953125 -8.796875 C -6.304688 -10.503906 -5.507813 -11.820313 -4.5625 -12.75 C -3.613281 -13.675781 -2.582031 -14.042969 -1.46875 -13.859375 C -0.25 -13.660156 0.566406 -12.957031 0.984375 -11.75 C 1.410156 -10.550781 1.472656 -9.023438 1.171875 -7.171875 C 0.566406 -3.484375 -0.800781 -1.816406 -2.9375 -2.171875 C -4.863281 -2.480469 -5.664063 -3.632813 -5.34375 -5.625 Z M -2.828125 -5.203125 C -2.804688 -5.324219 -2.816406 -5.453125 -2.859375 -5.578125 C -2.898438 -5.710938 -2.972656 -5.820313 -3.078125 -5.90625 C -3.191406 -5.996094 -3.3125 -6.054688 -3.4375 -6.078125 C -3.570313 -6.097656 -3.703125 -6.085938 -3.828125 -6.046875 C -3.960938 -6.003906 -4.070313 -5.925781 -4.15625 -5.8125 C -4.246094 -5.707031 -4.304688 -5.585938 -4.328125 -5.453125 C -4.347656 -5.316406 -4.332031 -5.183594 -4.28125 -5.0625 C -4.226563 -4.9375 -4.144531 -4.832031 -4.03125 -4.75 C -3.925781 -4.664063 -3.804688 -4.613281 -3.671875 -4.59375 C -3.546875 -4.570313 -3.414063 -4.582031 -3.28125 -4.625 C -3.15625 -4.675781 -3.050781 -4.753906 -2.96875 -4.859375 C -2.894531 -4.960938 -2.847656 -5.078125 -2.828125 -5.203125 Z M -2.828125 -5.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -9.140625 -4.625 C -8.609375 -4.488281 -8.273438 -4.691406 -8.140625 -5.234375 C -7.992188 -5.785156 -8.1875 -6.128906 -8.71875 -6.265625 C -9.269531 -6.410156 -9.617188 -6.207031 -9.765625 -5.65625 C -9.898438 -5.113281 -9.691406 -4.769531 -9.140625 -4.625 Z M 5.328125 -7.046875 C 5.804688 -6.023438 5.757813 -4.394531 5.1875 -2.15625 C 4.988281 -1.363281 4.714844 -0.585938 4.375 0.171875 L 2.8125 -0.234375 C 3.144531 -0.992188 3.410156 -1.769531 3.609375 -2.5625 C 3.816406 -3.382813 3.789063 -4.0625 3.53125 -4.59375 C 3.226563 -5.289063 2.558594 -5.769531 1.53125 -6.03125 L -6.84375 -8.171875 C -8.414063 -8.566406 -9.425781 -8.277344 -9.875 -7.3125 C -9.4375 -7.601563 -8.941406 -7.675781 -8.390625 -7.53125 C -7.003906 -7.175781 -6.492188 -6.300781 -6.859375 -4.90625 C -7.199219 -3.519531 -8.066406 -3.003906 -9.453125 -3.359375 C -11.335938 -3.835938 -11.972656 -5.296875 -11.359375 -7.734375 C -10.566406 -10.804688 -8.789063 -11.992188 -6.03125 -11.296875 L 2.34375 -9.15625 C 3.863281 -8.769531 4.859375 -8.066406 5.328125 -7.046875 Z M 5.328125 -7.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -8.125 -6.984375 C -7.957031 -7.410156 -8.097656 -7.71875 -8.546875 -7.90625 C -8.972656 -8.070313 -9.269531 -7.941406 -9.4375 -7.515625 C -9.613281 -7.085938 -9.488281 -6.789063 -9.0625 -6.625 C -8.613281 -6.4375 -8.300781 -6.554688 -8.125 -6.984375 Z M 3.234375 -15.875 C 3.085938 -15.507813 3.257813 -15.226563 3.75 -15.03125 C 4.246094 -14.832031 4.554688 -14.867188 4.671875 -15.140625 C 4.785156 -15.429688 4.429688 -15.742188 3.609375 -16.078125 L 3.375 -16.171875 C 3.320313 -16.078125 3.273438 -15.976563 3.234375 -15.875 Z M -5.75 -12.671875 L -6 -12.78125 C -6.820313 -13.101563 -7.289063 -13.117188 -7.40625 -12.828125 C -7.519531 -12.546875 -7.332031 -12.304688 -6.84375 -12.109375 C -6.34375 -11.910156 -6.019531 -12 -5.875 -12.375 C -5.832031 -12.476563 -5.789063 -12.578125 -5.75 -12.671875 Z M -2.625 -18.5625 C -3.382813 -18.863281 -3.9375 -18.917969 -4.28125 -18.734375 C -4.632813 -18.546875 -4.890625 -18.257813 -5.046875 -17.875 C -5.136719 -17.632813 -4.894531 -17.003906 -4.3125 -15.984375 L -3.9375 -15.421875 L 0.796875 -13.53125 C 3.441406 -12.476563 4.070313 -10.214844 2.6875 -6.75 C 1.300781 -3.269531 -0.648438 -2.035156 -3.171875 -3.046875 C -4.410156 -3.535156 -5.410156 -4.382813 -6.171875 -5.59375 C -6.441406 -5.996094 -6.695313 -6.359375 -6.9375 -6.671875 C -7.207031 -6.023438 -7.570313 -5.617188 -8.03125 -5.453125 C -8.445313 -5.296875 -8.929688 -5.332031 -9.484375 -5.5625 C -10.097656 -5.800781 -10.503906 -6.128906 -10.703125 -6.546875 C -10.917969 -6.980469 -10.898438 -7.523438 -10.640625 -8.171875 C -10.222656 -9.222656 -9.777344 -9.851563 -9.3125 -10.0625 C -8.851563 -10.269531 -8.316406 -10.253906 -7.703125 -10.015625 C -6.671875 -9.597656 -5.691406 -8.925781 -4.765625 -8 C -3.835938 -7.070313 -2.902344 -6.425781 -1.96875 -6.0625 C -0.457031 -5.457031 0.585938 -5.890625 1.171875 -7.359375 C 1.761719 -8.824219 1.242188 -9.882813 -0.390625 -10.53125 L -4.5625 -12.203125 L -4.671875 -11.921875 C -4.847656 -11.484375 -5.175781 -11.160156 -5.65625 -10.953125 C -6.132813 -10.753906 -6.675781 -10.773438 -7.28125 -11.015625 C -7.925781 -11.273438 -8.316406 -11.6875 -8.453125 -12.25 C -8.597656 -12.820313 -8.527344 -13.46875 -8.25 -14.1875 C -7.71875 -15.519531 -6.894531 -16.144531 -5.78125 -16.0625 C -6.464844 -17.207031 -6.628906 -18.238281 -6.265625 -19.15625 C -5.804688 -20.289063 -5.222656 -21.078125 -4.515625 -21.515625 C -3.679688 -22.035156 -2.652344 -22.050781 -1.4375 -21.5625 L 3.9375 -19.421875 L 4.578125 -19.5625 C 5.691406 -19.902344 6.34375 -20.304688 6.53125 -20.765625 C 6.652344 -21.074219 6.605469 -21.398438 6.390625 -21.734375 C 6.179688 -22.074219 5.761719 -22.367188 5.140625 -22.609375 L -3.515625 -26.0625 L -2.3125 -29.0625 L 6.34375 -25.609375 C 7.550781 -25.128906 8.28125 -24.402344 8.53125 -23.4375 C 8.757813 -22.632813 8.699219 -21.800781 8.359375 -20.9375 C 7.878906 -19.75 6.996094 -18.964844 5.71875 -18.59375 C 6.570313 -17.90625 6.621094 -16.617188 5.875 -14.734375 C 5.695313 -14.285156 5.382813 -13.949219 4.9375 -13.734375 C 4.488281 -13.523438 3.929688 -13.550781 3.265625 -13.8125 C 2.671875 -14.050781 2.273438 -14.425781 2.078125 -14.9375 C 1.890625 -15.457031 1.882813 -15.9375 2.0625 -16.375 L 2.171875 -16.65625 Z M -2.625 -18.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -18.1875 -2.765625 C -18.226563 -2.691406 -18.230469 -2.589844 -18.203125 -2.46875 C -18.171875 -2.351563 -18.113281 -2.242188 -18.03125 -2.140625 C -17.945313 -2.035156 -17.839844 -1.949219 -17.71875 -1.890625 C -17.582031 -1.828125 -17.441406 -1.785156 -17.296875 -1.765625 C -17.160156 -1.753906 -17.039063 -1.773438 -16.9375 -1.828125 C -16.84375 -1.878906 -16.773438 -1.941406 -16.734375 -2.015625 C -16.691406 -2.105469 -16.679688 -2.207031 -16.703125 -2.3125 C -16.722656 -2.425781 -16.78125 -2.535156 -16.875 -2.640625 C -16.964844 -2.742188 -17.082031 -2.828125 -17.21875 -2.890625 C -17.339844 -2.949219 -17.46875 -2.988281 -17.59375 -3 C -17.726563 -3.019531 -17.847656 -3.007813 -17.953125 -2.96875 C -18.066406 -2.925781 -18.144531 -2.855469 -18.1875 -2.765625 Z M -19.265625 -3.3125 C -19.066406 -3.683594 -18.800781 -4.015625 -18.46875 -4.296875 C -18.132813 -4.574219 -17.769531 -4.742188 -17.375 -4.796875 C -16.976563 -4.855469 -16.621094 -4.804688 -16.3125 -4.640625 C -15.988281 -4.484375 -15.730469 -4.230469 -15.546875 -3.890625 C -15.367188 -3.546875 -15.289063 -3.152344 -15.3125 -2.71875 C -15.332031 -2.28125 -15.441406 -1.863281 -15.640625 -1.46875 C -15.835938 -1.082031 -16.109375 -0.746094 -16.453125 -0.46875 C -16.792969 -0.195313 -17.160156 -0.0351563 -17.546875 0.015625 C -17.929688 0.0664063 -18.285156 0.0117188 -18.609375 -0.140625 C -18.917969 -0.304688 -19.171875 -0.5625 -19.359375 -0.90625 C -19.542969 -1.257813 -19.621094 -1.65625 -19.59375 -2.09375 C -19.5625 -2.527344 -19.449219 -2.9375 -19.265625 -3.3125 Z M -19.265625 -3.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.046875 -6.484375 C 1.992188 -6.699219 1.835938 -6.882813 1.578125 -7.03125 C 1.347656 -7.164063 1.136719 -7.210938 0.953125 -7.171875 C 0.742188 -7.140625 0.566406 -6.992188 0.421875 -6.734375 C 0.140625 -6.242188 0.242188 -5.851563 0.734375 -5.5625 C 1.023438 -5.394531 1.273438 -5.363281 1.484375 -5.46875 C 1.636719 -5.527344 1.773438 -5.664063 1.890625 -5.875 C 2.011719 -6.089844 2.066406 -6.296875 2.046875 -6.484375 Z M -0.859375 -6.40625 C -0.886719 -6.820313 -0.789063 -7.226563 -0.5625 -7.625 C -0.332031 -8.007813 0.0234375 -8.269531 0.515625 -8.40625 C 1.003906 -8.527344 1.554688 -8.410156 2.171875 -8.046875 C 2.792969 -7.691406 3.175781 -7.273438 3.3125 -6.796875 C 3.433594 -6.304688 3.242188 -5.621094 2.734375 -4.75 C 2.210938 -3.84375 1.644531 -3.238281 1.03125 -2.9375 C 0.175781 -2.53125 -0.8125 -2.648438 -1.9375 -3.296875 L -6.546875 -5.953125 C -7.941406 -6.761719 -8.734375 -7.617188 -8.921875 -8.515625 C -9.117188 -9.417969 -8.988281 -10.269531 -8.53125 -11.0625 C -8.050781 -11.894531 -7.175781 -12.335938 -5.90625 -12.390625 C -6.488281 -13.523438 -6.542969 -14.5 -6.078125 -15.3125 C -5.609375 -16.121094 -4.929688 -16.664063 -4.046875 -16.9375 C -3.171875 -17.214844 -2.039063 -16.957031 -0.65625 -16.15625 L 6.828125 -11.84375 L 5.21875 -9.046875 L -2.265625 -13.359375 C -3.792969 -14.242188 -4.640625 -14.550781 -4.796875 -14.28125 C -4.960938 -14 -4.738281 -13.023438 -4.125 -11.359375 C -5.863281 -11.066406 -6.816406 -10.777344 -6.984375 -10.5 C -7.136719 -10.21875 -6.449219 -9.632813 -4.921875 -8.75 Z M -0.859375 -6.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -17.328125 -0.796875 C -17.253906 -0.898438 -17.21875 -1.015625 -17.21875 -1.140625 C -17.21875 -1.273438 -17.242188 -1.40625 -17.296875 -1.53125 C -17.355469 -1.652344 -17.441406 -1.75 -17.546875 -1.8125 C -17.648438 -1.882813 -17.769531 -1.921875 -17.90625 -1.921875 C -18.039063 -1.929688 -18.160156 -1.898438 -18.265625 -1.828125 C -18.378906 -1.765625 -18.472656 -1.679688 -18.546875 -1.578125 C -18.617188 -1.472656 -18.660156 -1.351563 -18.671875 -1.21875 C -18.679688 -1.09375 -18.652344 -0.972656 -18.59375 -0.859375 C -18.53125 -0.742188 -18.445313 -0.648438 -18.34375 -0.578125 C -18.238281 -0.515625 -18.117188 -0.476563 -17.984375 -0.46875 C -17.847656 -0.457031 -17.714844 -0.484375 -17.59375 -0.546875 C -17.476563 -0.605469 -17.386719 -0.691406 -17.328125 -0.796875 Z M -17.875 -3 C -17.539063 -2.957031 -17.242188 -2.851563 -16.984375 -2.6875 C -16.722656 -2.519531 -16.507813 -2.289063 -16.34375 -2 C -16.1875 -1.707031 -16.117188 -1.398438 -16.140625 -1.078125 C -16.167969 -0.753906 -16.269531 -0.464844 -16.4375 -0.21875 C -16.800781 0.351563 -17.125 0.71875 -17.40625 0.875 C -17.695313 1.027344 -18.007813 1.097656 -18.34375 1.078125 C -18.675781 1.054688 -18.972656 0.960938 -19.234375 0.796875 C -20.097656 0.234375 -20.507813 -0.539063 -20.46875 -1.53125 C -20.425781 -2.527344 -20.058594 -3.570313 -19.375 -4.65625 C -18.539063 -5.933594 -17.507813 -6.863281 -16.28125 -7.4375 C -15.050781 -8.007813 -13.691406 -7.929688 -12.203125 -7.203125 L -13.953125 -4.484375 C -14.949219 -4.992188 -15.769531 -5.207031 -16.40625 -5.125 C -17.039063 -5.050781 -17.507813 -4.777344 -17.8125 -4.3125 C -18.152344 -3.78125 -18.175781 -3.339844 -17.875 -3 Z M -17.875 -3 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.421875 -6.578125 C -1.441406 -6.421875 -1.417969 -6.273438 -1.359375 -6.140625 C -1.304688 -6.003906 -1.214844 -5.886719 -1.09375 -5.796875 C -0.96875 -5.710938 -0.824219 -5.660156 -0.671875 -5.640625 C -0.515625 -5.617188 -0.367188 -5.640625 -0.234375 -5.703125 C -0.109375 -5.761719 0 -5.863281 0.09375 -6 C 0.175781 -6.113281 0.226563 -6.242188 0.25 -6.390625 C 0.269531 -6.542969 0.246094 -6.691406 0.1875 -6.828125 C 0.125 -6.960938 0.0273438 -7.070313 -0.09375 -7.15625 C -0.214844 -7.246094 -0.351563 -7.300781 -0.5 -7.3125 C -0.652344 -7.332031 -0.800781 -7.308594 -0.9375 -7.25 C -1.082031 -7.1875 -1.195313 -7.101563 -1.28125 -7 C -1.363281 -6.875 -1.410156 -6.730469 -1.421875 -6.578125 Z M -6.140625 -6.46875 C -8.386719 -8.082031 -8.367188 -10.484375 -6.078125 -13.671875 C -3.785156 -16.855469 -1.480469 -17.617188 0.828125 -15.953125 L 4.375 -13.390625 C 5.527344 -12.566406 6.125 -11.566406 6.15625 -10.390625 C 6.195313 -9.222656 5.613281 -7.800781 4.40625 -6.125 C 3.207031 -4.445313 2.042969 -3.433594 0.921875 -3.09375 C -0.199219 -2.757813 -1.34375 -3.003906 -2.5 -3.828125 C -2.800781 -4.054688 -3.035156 -4.34375 -3.203125 -4.6875 C -3.367188 -5.039063 -3.414063 -5.425781 -3.34375 -5.84375 C -3.269531 -6.269531 -2.929688 -6.90625 -2.328125 -7.75 C -2.117188 -8.027344 -1.835938 -8.253906 -1.484375 -8.421875 C -1.140625 -8.597656 -0.769531 -8.664063 -0.375 -8.625 C 0.0078125 -8.582031 0.351563 -8.445313 0.65625 -8.21875 C 0.964844 -8 1.203125 -7.710938 1.359375 -7.359375 C 1.523438 -7.015625 1.585938 -6.652344 1.546875 -6.28125 C 1.515625 -6.050781 1.460938 -5.835938 1.390625 -5.640625 C 2.128906 -6.042969 2.695313 -6.523438 3.09375 -7.078125 C 4.132813 -8.511719 3.933594 -9.742188 2.5 -10.765625 L -1.046875 -13.328125 C -2.480469 -14.355469 -3.722656 -14.152344 -4.765625 -12.71875 C -5.792969 -11.28125 -5.621094 -10.070313 -4.25 -9.09375 Z M -6.140625 -6.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.390625 -11.84375 C 7.367188 -11.75 7.375 -11.652344 7.40625 -11.5625 C 7.445313 -11.46875 7.503906 -11.382813 7.578125 -11.3125 C 7.648438 -11.25 7.734375 -11.207031 7.828125 -11.1875 C 7.917969 -11.164063 8.015625 -11.164063 8.109375 -11.1875 C 8.210938 -11.214844 8.296875 -11.269531 8.359375 -11.34375 C 8.429688 -11.414063 8.472656 -11.503906 8.484375 -11.609375 C 8.503906 -11.710938 8.496094 -11.8125 8.46875 -11.90625 C 8.4375 -11.996094 8.382813 -12.078125 8.3125 -12.140625 C 8.238281 -12.210938 8.148438 -12.253906 8.046875 -12.265625 C 7.941406 -12.285156 7.839844 -12.277344 7.75 -12.25 C 7.664063 -12.21875 7.585938 -12.164063 7.515625 -12.09375 C 7.453125 -12.019531 7.410156 -11.933594 7.390625 -11.84375 Z M 6.34375 -12.234375 C 6.414063 -12.460938 6.53125 -12.664063 6.6875 -12.84375 C 6.882813 -13.058594 7.125 -13.222656 7.40625 -13.328125 C 7.695313 -13.429688 7.988281 -13.445313 8.28125 -13.375 C 8.582031 -13.300781 8.84375 -13.164063 9.0625 -12.96875 C 9.519531 -12.5625 9.765625 -12.128906 9.796875 -11.671875 C 9.816406 -11.203125 9.597656 -10.710938 9.140625 -10.203125 C 8.367188 -9.347656 7.589844 -8.867188 6.8125 -8.765625 C 5.96875 -8.660156 5.105469 -9 4.234375 -9.78125 L -0.359375 -13.90625 C -1.230469 -14.683594 -1.671875 -15.503906 -1.671875 -16.359375 C -1.660156 -17.136719 -1.277344 -17.945313 -0.53125 -18.78125 C -0.09375 -19.269531 0.453125 -19.707031 1.109375 -20.09375 L 2.3125 -19.015625 C 1.757813 -18.734375 1.386719 -18.488281 1.203125 -18.28125 C 0.953125 -18 0.867188 -17.699219 0.953125 -17.390625 C 1.035156 -17.085938 1.316406 -16.726563 1.796875 -16.3125 Z M 1.90625 -5.71875 C 1.882813 -5.625 1.890625 -5.523438 1.921875 -5.421875 C 1.949219 -5.328125 2.003906 -5.242188 2.078125 -5.171875 C 2.148438 -5.109375 2.234375 -5.066406 2.328125 -5.046875 C 2.429688 -5.035156 2.53125 -5.039063 2.625 -5.0625 C 2.726563 -5.089844 2.8125 -5.144531 2.875 -5.21875 C 2.945313 -5.300781 2.988281 -5.390625 3 -5.484375 C 3.019531 -5.585938 3.011719 -5.6875 2.984375 -5.78125 C 2.953125 -5.871094 2.898438 -5.953125 2.828125 -6.015625 C 2.753906 -6.085938 2.664063 -6.128906 2.5625 -6.140625 C 2.46875 -6.160156 2.371094 -6.152344 2.28125 -6.125 C 2.1875 -6.101563 2.101563 -6.050781 2.03125 -5.96875 C 1.96875 -5.894531 1.925781 -5.808594 1.90625 -5.71875 Z M 0.859375 -6.109375 C 0.929688 -6.335938 1.046875 -6.539063 1.203125 -6.71875 C 1.398438 -6.933594 1.640625 -7.097656 1.921875 -7.203125 C 2.210938 -7.304688 2.503906 -7.320313 2.796875 -7.25 C 3.097656 -7.1875 3.359375 -7.054688 3.578125 -6.859375 C 4.035156 -6.453125 4.28125 -6.011719 4.3125 -5.546875 C 4.332031 -5.085938 4.113281 -4.597656 3.65625 -4.078125 C 2.882813 -3.222656 2.105469 -2.742188 1.328125 -2.640625 C 0.484375 -2.535156 -0.375 -2.875 -1.25 -3.65625 L -5.84375 -7.78125 C -6.714844 -8.558594 -7.15625 -9.378906 -7.15625 -10.234375 C -7.144531 -11.011719 -6.761719 -11.820313 -6.015625 -12.65625 C -5.566406 -13.144531 -5.019531 -13.585938 -4.375 -13.984375 L -3.171875 -12.90625 C -3.722656 -12.613281 -4.09375 -12.363281 -4.28125 -12.15625 C -4.519531 -11.882813 -4.597656 -11.589844 -4.515625 -11.28125 C -4.441406 -10.96875 -4.164063 -10.601563 -3.6875 -10.1875 Z M 0.859375 -6.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph9-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph9-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -4.234375 -9.859375 C -3.890625 -10.160156 -3.875 -10.488281 -4.1875 -10.84375 C -4.507813 -11.195313 -4.84375 -11.222656 -5.1875 -10.921875 C -5.519531 -10.609375 -5.523438 -10.273438 -5.203125 -9.921875 C -4.890625 -9.566406 -4.566406 -9.546875 -4.234375 -9.859375 Z M -4.8125 -8.4375 C -5.238281 -8.476563 -5.648438 -8.71875 -6.046875 -9.15625 C -6.492188 -9.652344 -6.71875 -10.128906 -6.71875 -10.578125 C -6.726563 -11.074219 -6.476563 -11.5625 -5.96875 -12.03125 C -5.125 -12.789063 -4.441406 -13.160156 -3.921875 -13.140625 C -3.429688 -13.117188 -2.960938 -12.855469 -2.515625 -12.359375 C -1.773438 -11.546875 -1.191406 -10.519531 -0.765625 -9.28125 C -0.335938 -8.039063 0.210938 -7.042969 0.890625 -6.296875 C 1.980469 -5.085938 3.117188 -5.015625 4.296875 -6.078125 C 5.460938 -7.136719 5.457031 -8.320313 4.28125 -9.625 L -1.53125 -16.046875 L 0.875 -18.21875 L 6.6875 -11.796875 C 8.589844 -9.691406 8.160156 -7.382813 5.390625 -4.875 C 2.617188 -2.363281 0.320313 -2.113281 -1.5 -4.125 C -2.394531 -5.113281 -2.925781 -6.320313 -3.09375 -7.75 C -3.144531 -8.226563 -3.21875 -8.65625 -3.3125 -9.03125 C -3.832031 -8.582031 -4.332031 -8.382813 -4.8125 -8.4375 Z M -4.8125 -8.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph10-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph10-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.25 -10.21875 C -2.882813 -10.488281 -2.847656 -10.816406 -3.140625 -11.203125 C -3.417969 -11.574219 -3.742188 -11.628906 -4.109375 -11.359375 C -4.472656 -11.085938 -4.511719 -10.761719 -4.234375 -10.390625 C -3.941406 -10.003906 -3.613281 -9.945313 -3.25 -10.21875 Z M -3.96875 -8.859375 C -4.402344 -8.941406 -4.800781 -9.222656 -5.15625 -9.703125 C -5.550781 -10.230469 -5.722656 -10.726563 -5.671875 -11.1875 C -5.640625 -11.683594 -5.339844 -12.144531 -4.78125 -12.5625 C -3.882813 -13.226563 -3.175781 -13.523438 -2.65625 -13.453125 C -2.15625 -13.390625 -1.707031 -13.089844 -1.3125 -12.5625 C -0.65625 -11.675781 -0.175781 -10.589844 0.125 -9.3125 C 0.433594 -8.03125 0.890625 -6.988281 1.484375 -6.1875 C 2.460938 -4.875 3.585938 -4.691406 4.859375 -5.640625 C 6.128906 -6.574219 6.238281 -7.753906 5.1875 -9.171875 L 0.015625 -16.125 L 2.609375 -18.0625 L 7.78125 -11.109375 C 9.476563 -8.828125 8.824219 -6.570313 5.828125 -4.34375 C 2.828125 -2.101563 0.511719 -2.070313 -1.109375 -4.25 C -1.898438 -5.320313 -2.304688 -6.570313 -2.328125 -8 C -2.335938 -8.488281 -2.375 -8.925781 -2.4375 -9.3125 C -2.988281 -8.90625 -3.5 -8.753906 -3.96875 -8.859375 Z M -3.96875 -8.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph11-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph11-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.140625 -13.796875 C 2.773438 -13.929688 2.382813 -14 1.96875 -14 C 1.5625 -14 0.886719 -13.714844 -0.046875 -13.15625 C -0.597656 -12.820313 -0.925781 -12.457031 -1.03125 -12.0625 C -1.132813 -11.664063 -1.101563 -11.324219 -0.9375 -11.046875 C -0.769531 -10.765625 -0.511719 -10.625 -0.171875 -10.625 C 0.160156 -10.625 0.601563 -10.789063 1.15625 -11.125 C 2.089844 -11.683594 2.65625 -12.144531 2.84375 -12.5 C 3.027344 -12.863281 3.128906 -13.296875 3.140625 -13.796875 Z M 3.5 -3.1875 C 3.957031 -3.464844 4.050781 -3.835938 3.78125 -4.296875 C 3.507813 -4.742188 3.144531 -4.824219 2.6875 -4.546875 C 2.25 -4.285156 2.164063 -3.929688 2.4375 -3.484375 C 2.707031 -3.023438 3.0625 -2.925781 3.5 -3.1875 Z M 3.3125 -15.875 C 3.175781 -16.332031 2.960938 -16.820313 2.671875 -17.34375 L 4.75 -18.1875 C 5.144531 -17.332031 5.414063 -16.542969 5.5625 -15.828125 C 6.113281 -15.578125 6.550781 -15.179688 6.875 -14.640625 L 10.25 -9.03125 C 10.683594 -8.300781 10.800781 -7.636719 10.59375 -7.046875 C 10.394531 -6.472656 9.933594 -5.964844 9.21875 -5.53125 C 8.488281 -5.101563 7.847656 -4.894531 7.296875 -4.90625 C 6.753906 -4.925781 6.195313 -5.1875 5.625 -5.6875 C 5.0625 -6.195313 4.535156 -6.515625 4.046875 -6.640625 C 3.566406 -6.773438 2.992188 -6.644531 2.328125 -6.25 C 2.015625 -6.0625 1.925781 -5.800781 2.0625 -5.46875 C 2.664063 -5.832031 3.1875 -5.980469 3.625 -5.921875 C 4.027344 -5.859375 4.367188 -5.605469 4.640625 -5.171875 C 4.710938 -5.066406 4.773438 -4.964844 4.828125 -4.875 C 5.085938 -4.4375 5.160156 -4.019531 5.046875 -3.625 C 4.898438 -3.15625 4.488281 -2.710938 3.8125 -2.296875 C 3.007813 -1.835938 2.285156 -1.691406 1.640625 -1.859375 C 0.984375 -2.035156 0.402344 -2.539063 -0.09375 -3.375 C -0.519531 -4.082031 -0.613281 -4.8125 -0.375 -5.5625 C -0.144531 -6.320313 0.476563 -7.007813 1.5 -7.625 C 2.425781 -8.183594 3.253906 -8.402344 3.984375 -8.28125 C 4.710938 -8.164063 5.445313 -7.804688 6.1875 -7.203125 C 6.933594 -6.597656 7.410156 -6.351563 7.609375 -6.46875 C 7.804688 -6.582031 7.761719 -6.878906 7.484375 -7.359375 L 4.375 -12.515625 C 4.15625 -11.492188 3.355469 -10.570313 1.984375 -9.75 C 0.484375 -8.84375 -0.710938 -8.339844 -1.609375 -8.25 C -2.503906 -8.164063 -3.203125 -8.546875 -3.703125 -9.390625 C -4.199219 -10.222656 -4.230469 -11.0625 -3.796875 -11.90625 C -3.359375 -12.757813 -2.386719 -13.640625 -0.890625 -14.546875 C 0.585938 -15.429688 1.988281 -15.875 3.3125 -15.875 Z M 3.3125 -15.875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph12-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph12-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -14.78125 -9.09375 C -14.664063 -9.152344 -14.570313 -9.238281 -14.5 -9.34375 C -14.4375 -9.457031 -14.398438 -9.582031 -14.390625 -9.71875 C -14.390625 -9.863281 -14.414063 -9.988281 -14.46875 -10.09375 C -14.527344 -10.207031 -14.617188 -10.300781 -14.734375 -10.375 C -14.847656 -10.445313 -14.96875 -10.476563 -15.09375 -10.46875 C -15.226563 -10.46875 -15.351563 -10.433594 -15.46875 -10.375 C -15.570313 -10.3125 -15.660156 -10.226563 -15.734375 -10.125 C -15.816406 -10.019531 -15.851563 -9.898438 -15.84375 -9.765625 C -15.84375 -9.628906 -15.808594 -9.503906 -15.75 -9.390625 C -15.695313 -9.285156 -15.613281 -9.195313 -15.5 -9.125 C -15.394531 -9.050781 -15.273438 -9.015625 -15.140625 -9.015625 C -15.003906 -9.015625 -14.882813 -9.039063 -14.78125 -9.09375 Z M -14.1875 -11.265625 C -13.894531 -11.085938 -13.675781 -10.855469 -13.53125 -10.578125 C -13.382813 -10.304688 -13.316406 -10.003906 -13.328125 -9.671875 C -13.335938 -9.347656 -13.429688 -9.050781 -13.609375 -8.78125 C -13.785156 -8.507813 -14.007813 -8.300781 -14.28125 -8.15625 C -14.871094 -7.832031 -15.332031 -7.671875 -15.65625 -7.671875 C -15.988281 -7.671875 -16.289063 -7.757813 -16.5625 -7.9375 C -16.839844 -8.121094 -17.054688 -8.351563 -17.203125 -8.625 C -17.691406 -9.539063 -17.675781 -10.425781 -17.15625 -11.28125 C -16.644531 -12.132813 -15.820313 -12.863281 -14.6875 -13.46875 C -13.332031 -14.183594 -11.976563 -14.492188 -10.625 -14.390625 C -9.28125 -14.296875 -8.132813 -13.570313 -7.1875 -12.21875 L -10.03125 -10.6875 C -10.652344 -11.613281 -11.265625 -12.195313 -11.859375 -12.4375 C -12.449219 -12.675781 -12.992188 -12.664063 -13.484375 -12.40625 C -14.042969 -12.101563 -14.277344 -11.722656 -14.1875 -11.265625 Z M -14.1875 -11.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph12-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -17.15625 -17.359375 L -15.234375 -18.390625 L -13.203125 -14.59375 L -15.125 -13.5625 Z M -17.15625 -17.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph13-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph13-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.375 -9.953125 C -2.132813 -9.460938 -1.761719 -9.34375 -1.265625 -9.59375 C -0.742188 -9.839844 -0.601563 -10.210938 -0.84375 -10.703125 C -1.101563 -11.222656 -1.492188 -11.355469 -2.015625 -11.109375 C -2.511719 -10.859375 -2.632813 -10.472656 -2.375 -9.953125 Z M 8.828125 -0.484375 C 8.359375 0.535156 7.082031 1.550781 5 2.5625 C 4.257813 2.925781 3.492188 3.210938 2.703125 3.421875 L 1.984375 1.984375 C 2.785156 1.753906 3.554688 1.457031 4.296875 1.09375 C 5.054688 0.726563 5.554688 0.273438 5.796875 -0.265625 C 6.128906 -0.941406 6.058594 -1.757813 5.59375 -2.71875 L 1.8125 -10.484375 C 1.09375 -11.941406 0.214844 -12.527344 -0.8125 -12.25 C -0.320313 -12.113281 0.0507813 -11.785156 0.3125 -11.265625 C 0.933594 -9.984375 0.601563 -9.027344 -0.6875 -8.40625 C -1.964844 -7.78125 -2.921875 -8.109375 -3.546875 -9.390625 C -4.398438 -11.136719 -3.695313 -12.5625 -1.4375 -13.65625 C 1.414063 -15.050781 3.46875 -14.464844 4.71875 -11.90625 L 8.5 -4.140625 C 9.183594 -2.722656 9.292969 -1.503906 8.828125 -0.484375 Z M 8.828125 -0.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph14-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph14-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.21875 -4.296875 C 4.164063 -4.222656 4.128906 -4.132813 4.109375 -4.03125 C 4.085938 -3.9375 4.097656 -3.839844 4.140625 -3.75 C 4.167969 -3.664063 4.226563 -3.585938 4.3125 -3.515625 C 4.402344 -3.453125 4.5 -3.414063 4.59375 -3.40625 C 4.695313 -3.394531 4.796875 -3.40625 4.890625 -3.4375 C 4.980469 -3.476563 5.0625 -3.535156 5.125 -3.609375 C 5.183594 -3.691406 5.21875 -3.785156 5.21875 -3.890625 C 5.226563 -3.992188 5.214844 -4.085938 5.1875 -4.171875 C 5.144531 -4.261719 5.082031 -4.34375 5 -4.40625 C 4.925781 -4.464844 4.835938 -4.503906 4.734375 -4.515625 C 4.640625 -4.523438 4.542969 -4.507813 4.453125 -4.46875 C 4.359375 -4.4375 4.277344 -4.378906 4.21875 -4.296875 Z M 3.453125 -5.125 C 3.605469 -5.289063 3.800781 -5.421875 4.03125 -5.515625 C 4.300781 -5.628906 4.585938 -5.664063 4.890625 -5.625 C 5.191406 -5.59375 5.460938 -5.476563 5.703125 -5.28125 C 5.949219 -5.09375 6.128906 -4.863281 6.234375 -4.59375 C 6.460938 -4.019531 6.488281 -3.523438 6.3125 -3.109375 C 6.125 -2.671875 5.710938 -2.320313 5.078125 -2.0625 C 4.003906 -1.625 3.097656 -1.535156 2.359375 -1.796875 C 1.546875 -2.074219 0.917969 -2.757813 0.484375 -3.84375 L -1.84375 -9.5625 C -2.289063 -10.652344 -2.316406 -11.582031 -1.921875 -12.34375 C -1.578125 -13.027344 -0.882813 -13.582031 0.15625 -14 C 0.769531 -14.246094 1.457031 -14.410156 2.21875 -14.484375 L 2.828125 -12.984375 C 2.203125 -12.972656 1.757813 -12.914063 1.5 -12.8125 C 1.15625 -12.664063 0.949219 -12.433594 0.890625 -12.125 C 0.828125 -11.820313 0.914063 -11.371094 1.15625 -10.78125 Z M 3.453125 -5.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph15-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph15-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.28125 -12.6875 C 5.945313 -12.882813 5.582031 -13.035156 5.1875 -13.140625 C 4.789063 -13.242188 4.070313 -13.132813 3.03125 -12.8125 C 2.414063 -12.613281 2.007813 -12.332031 1.8125 -11.96875 C 1.625 -11.601563 1.578125 -11.269531 1.671875 -10.96875 C 1.773438 -10.65625 1.988281 -10.457031 2.3125 -10.375 C 2.644531 -10.300781 3.117188 -10.363281 3.734375 -10.5625 C 4.773438 -10.882813 5.425781 -11.195313 5.6875 -11.5 C 5.945313 -11.800781 6.144531 -12.195313 6.28125 -12.6875 Z M 4.15625 -2.296875 C 4.664063 -2.449219 4.839844 -2.785156 4.6875 -3.296875 C 4.53125 -3.792969 4.195313 -3.964844 3.6875 -3.8125 C 3.195313 -3.65625 3.03125 -3.324219 3.1875 -2.828125 C 3.339844 -2.316406 3.664063 -2.140625 4.15625 -2.296875 Z M 6.921875 -14.671875 C 6.898438 -15.136719 6.816406 -15.660156 6.671875 -16.234375 L 8.859375 -16.578125 C 9.042969 -15.648438 9.128906 -14.820313 9.109375 -14.09375 C 9.574219 -13.726563 9.910156 -13.238281 10.109375 -12.625 L 12.0625 -6.40625 C 12.320313 -5.582031 12.277344 -4.898438 11.9375 -4.359375 C 11.613281 -3.859375 11.050781 -3.480469 10.25 -3.234375 C 9.445313 -2.984375 8.777344 -2.925781 8.25 -3.0625 C 7.71875 -3.207031 7.230469 -3.59375 6.796875 -4.21875 C 6.367188 -4.839844 5.929688 -5.273438 5.484375 -5.515625 C 5.046875 -5.761719 4.460938 -5.769531 3.734375 -5.53125 C 3.378906 -5.425781 3.222656 -5.191406 3.265625 -4.828125 C 3.941406 -5.042969 4.488281 -5.070313 4.90625 -4.90625 C 5.289063 -4.757813 5.5625 -4.441406 5.71875 -3.953125 C 5.757813 -3.828125 5.800781 -3.710938 5.84375 -3.609375 C 5.988281 -3.128906 5.960938 -2.707031 5.765625 -2.34375 C 5.515625 -1.925781 5.007813 -1.589844 4.25 -1.34375 C 3.351563 -1.082031 2.617188 -1.113281 2.046875 -1.4375 C 1.429688 -1.757813 0.976563 -2.378906 0.6875 -3.296875 C 0.445313 -4.085938 0.523438 -4.820313 0.921875 -5.5 C 1.324219 -6.183594 2.101563 -6.707031 3.25 -7.0625 C 4.277344 -7.394531 5.132813 -7.414063 5.8125 -7.125 C 6.488281 -6.84375 7.117188 -6.316406 7.703125 -5.546875 C 8.292969 -4.785156 8.703125 -4.441406 8.921875 -4.515625 C 9.136719 -4.574219 9.160156 -4.878906 8.984375 -5.421875 L 7.1875 -11.15625 C 6.726563 -10.207031 5.738281 -9.492188 4.21875 -9.015625 C 2.550781 -8.484375 1.269531 -8.28125 0.375 -8.40625 C -0.519531 -8.527344 -1.117188 -9.0625 -1.421875 -10 C -1.710938 -10.914063 -1.539063 -11.738281 -0.90625 -12.46875 C -0.28125 -13.195313 0.863281 -13.828125 2.53125 -14.359375 C 4.164063 -14.867188 5.628906 -14.972656 6.921875 -14.671875 Z M 6.921875 -14.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph16-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph16-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -9.671875 -13.4375 C -9.398438 -13.832031 -9.195313 -14.140625 -9.0625 -14.359375 C -8.976563 -14.472656 -8.953125 -14.59375 -8.984375 -14.71875 C -9.003906 -14.789063 -9.046875 -14.859375 -9.109375 -14.921875 C -9.261719 -15.105469 -9.476563 -15.234375 -9.75 -15.296875 C -10.027344 -15.355469 -10.625 -15.269531 -11.53125 -15.03125 L -11.734375 -14.984375 C -12.628906 -14.742188 -13.175781 -14.527344 -13.375 -14.34375 C -13.582031 -14.15625 -13.71875 -13.941406 -13.78125 -13.703125 C -13.789063 -13.617188 -13.785156 -13.539063 -13.765625 -13.46875 C -13.734375 -13.34375 -13.652344 -13.246094 -13.53125 -13.1875 C -13.3125 -13.070313 -12.980469 -12.902344 -12.546875 -12.6875 L -12.875 -11.640625 C -12.925781 -11.628906 -12.976563 -11.617188 -13.03125 -11.609375 C -13.402344 -11.617188 -13.726563 -11.65625 -14 -11.71875 C -14.269531 -11.789063 -14.550781 -11.890625 -14.84375 -12.015625 C -15.132813 -12.136719 -15.332031 -12.257813 -15.4375 -12.375 C -15.550781 -12.488281 -15.671875 -12.691406 -15.796875 -12.984375 C -15.867188 -13.273438 -15.769531 -13.625 -15.5 -14.03125 C -15.226563 -14.445313 -14.816406 -14.8125 -14.265625 -15.125 C -13.722656 -15.445313 -12.933594 -15.742188 -11.90625 -16.015625 C -10.863281 -16.285156 -10.019531 -16.414063 -9.375 -16.40625 C -8.726563 -16.394531 -8.191406 -16.273438 -7.765625 -16.046875 C -7.335938 -15.828125 -7.085938 -15.570313 -7.015625 -15.28125 C -6.984375 -15.03125 -6.988281 -14.820313 -7.03125 -14.65625 C -7.039063 -14.5625 -7.082031 -14.425781 -7.15625 -14.25 L -5.78125 -14.609375 L -5.5 -13.5625 L -9.4375 -12.546875 Z M -9.671875 -13.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph17-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph17-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.3125 -2.296875 C 2.769531 -2.386719 2.949219 -2.660156 2.859375 -3.109375 C 2.773438 -3.554688 2.503906 -3.730469 2.046875 -3.640625 C 1.597656 -3.546875 1.414063 -3.273438 1.5 -2.828125 C 1.589844 -2.378906 1.863281 -2.203125 2.3125 -2.296875 Z M 6.125 -5.265625 C 6.195313 -4.867188 6.238281 -4.496094 6.25 -4.15625 C 6.675781 -4.207031 7.144531 -4.070313 7.65625 -3.75 C 8.132813 -3.5 8.695313 -3.4375 9.34375 -3.5625 C 10.164063 -3.726563 10.445313 -4.453125 10.1875 -5.734375 L 8.328125 -14.875 L 11.484375 -15.53125 L 13.34375 -6.390625 C 13.820313 -4.046875 12.667969 -2.585938 9.890625 -2.015625 C 8.785156 -1.796875 7.792969 -1.992188 6.921875 -2.609375 C 6.617188 -2.824219 6.324219 -2.917969 6.046875 -2.890625 C 5.617188 -1.703125 4.835938 -0.988281 3.703125 -0.75 C 1.835938 -0.375 0.738281 -0.992188 0.40625 -2.609375 C 0.164063 -3.792969 0.632813 -4.507813 1.8125 -4.75 C 2.246094 -4.832031 2.617188 -4.824219 2.921875 -4.734375 L 1.15625 -13.421875 L 4.328125 -14.0625 Z M 6.125 -5.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph18-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph18-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2 -2.328125 C 2.050781 -1.773438 2.359375 -1.53125 2.921875 -1.59375 C 3.492188 -1.644531 3.753906 -1.945313 3.703125 -2.5 C 3.648438 -3.070313 3.335938 -3.332031 2.765625 -3.28125 C 2.203125 -3.21875 1.945313 -2.898438 2 -2.328125 Z M 2.84375 -10.359375 L 2.8125 -10.625 C 2.726563 -11.507813 2.417969 -11.925781 1.890625 -11.875 C 1.359375 -11.820313 1.117188 -11.527344 1.171875 -11 C 1.222656 -10.46875 1.675781 -10.242188 2.53125 -10.328125 C 2.632813 -10.335938 2.738281 -10.347656 2.84375 -10.359375 Z M 6.15625 -1.25 C 5.726563 -0.769531 4.691406 -0.449219 3.046875 -0.296875 C 2.285156 -0.222656 1.710938 -0.367188 1.328125 -0.734375 C 0.984375 -1.066406 0.777344 -1.5625 0.71875 -2.21875 C 0.65625 -2.894531 0.765625 -3.421875 1.046875 -3.796875 C 1.355469 -4.242188 1.890625 -4.503906 2.640625 -4.578125 C 2.917969 -4.597656 3.171875 -4.589844 3.390625 -4.5625 L 2.96875 -9.078125 L 2.671875 -9.046875 C 1.742188 -8.960938 1.050781 -9.097656 0.59375 -9.453125 C 0.1875 -9.761719 -0.046875 -10.242188 -0.109375 -10.890625 C -0.167969 -11.585938 -0.0351563 -12.117188 0.296875 -12.484375 C 0.617188 -12.855469 1.128906 -13.082031 1.828125 -13.15625 C 4.074219 -13.363281 5.40625 -12.957031 5.8125 -11.9375 C 6.550781 -13.070313 7.632813 -13.707031 9.0625 -13.84375 C 10.269531 -13.957031 11.226563 -13.789063 11.9375 -13.34375 C 12.800781 -12.84375 13.289063 -11.941406 13.40625 -10.640625 L 14.296875 -1.359375 L 11.078125 -1.046875 L 10.1875 -10.328125 C 10.125 -10.992188 9.878906 -11.472656 9.453125 -11.765625 C 9.054688 -12.042969 8.617188 -12.164063 8.140625 -12.125 C 7.660156 -12.082031 7.097656 -11.566406 6.453125 -10.578125 L 6.125 -10 L 6.734375 -3.578125 C 6.835938 -2.554688 6.644531 -1.777344 6.15625 -1.25 Z M 6.15625 -1.25 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph19-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph19-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.46875 -10.0625 C 3.46875 -9.507813 3.640625 -9.234375 3.984375 -9.234375 C 4.324219 -9.242188 4.5 -9.523438 4.5 -10.078125 C 4.488281 -10.417969 4.308594 -10.585938 3.96875 -10.578125 C 3.625 -10.578125 3.457031 -10.402344 3.46875 -10.0625 Z M 6.390625 -0.109375 L 6.25 -8.75 C 6.238281 -9.632813 6.082031 -10.082031 5.78125 -10.09375 C 5.800781 -8.664063 5.089844 -7.941406 3.65625 -7.921875 C 2.238281 -7.898438 1.519531 -8.601563 1.5 -10.03125 C 1.46875 -11.976563 2.59375 -12.96875 4.875 -13 C 7.902344 -13.050781 9.441406 -11.648438 9.484375 -8.796875 L 9.625 -0.15625 Z M 6.390625 -0.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph20-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph20-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.90625 -9.625 C 4.476563 -9.570313 4.785156 -9.820313 4.828125 -10.375 C 4.878906 -10.933594 4.617188 -11.242188 4.046875 -11.296875 C 3.484375 -11.347656 3.175781 -11.089844 3.125 -10.53125 C 3.082031 -9.976563 3.34375 -9.675781 3.90625 -9.625 Z M 4.546875 -8.34375 C 4.316406 -8.3125 4.058594 -8.304688 3.78125 -8.328125 C 3.039063 -8.386719 2.507813 -8.640625 2.1875 -9.078125 C 1.90625 -9.460938 1.789063 -9.984375 1.84375 -10.640625 C 1.902344 -11.304688 2.109375 -11.804688 2.453125 -12.140625 C 2.835938 -12.511719 3.40625 -12.667969 4.15625 -12.609375 C 5.808594 -12.472656 6.851563 -12.164063 7.28125 -11.6875 C 7.757813 -11.144531 7.957031 -10.367188 7.875 -9.359375 L 7.359375 -3.3125 C 7.316406 -2.90625 7.253906 -2.539063 7.171875 -2.21875 C 7.597656 -2.144531 8.007813 -1.878906 8.40625 -1.421875 C 8.800781 -1.046875 9.328125 -0.832031 9.984375 -0.78125 C 10.804688 -0.707031 11.273438 -1.320313 11.390625 -2.625 L 12.1875 -11.921875 L 15.421875 -11.640625 L 14.625 -2.34375 C 14.414063 0.0390625 12.894531 1.105469 10.0625 0.859375 C 8.9375 0.765625 8.039063 0.289063 7.375 -0.5625 C 7.144531 -0.839844 6.886719 -1.007813 6.609375 -1.0625 C 5.867188 -0.0390625 4.214844 0.355469 1.65625 0.140625 L 1.796875 -1.484375 C 2.503906 -1.421875 3.050781 -1.5625 3.4375 -1.90625 C 3.832031 -2.257813 4.066406 -2.820313 4.140625 -3.59375 Z M 4.546875 -8.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph21-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph21-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.75 -0.046875 C 5.269531 0.0546875 5.582031 -0.148438 5.6875 -0.671875 C 5.777344 -1.179688 5.566406 -1.488281 5.046875 -1.59375 C 4.535156 -1.683594 4.230469 -1.476563 4.140625 -0.96875 C 4.035156 -0.445313 4.238281 -0.136719 4.75 -0.046875 Z M 6.1875 0.671875 C 5.769531 0.917969 5.164063 0.976563 4.375 0.84375 C 3.457031 0.644531 2.820313 0.269531 2.46875 -0.28125 C 2.09375 -0.851563 1.992188 -1.617188 2.171875 -2.578125 C 2.410156 -3.816406 2.867188 -4.648438 3.546875 -5.078125 C 4.230469 -5.492188 5.28125 -5.566406 6.6875 -5.296875 C 7.519531 -5.140625 8.144531 -4.660156 8.5625 -3.859375 C 8.976563 -3.054688 9.265625 -2.175781 9.421875 -1.21875 C 9.574219 -0.269531 9.769531 0.222656 10 0.265625 C 10.214844 0.304688 10.378906 0.0507813 10.484375 -0.5 L 11.703125 -6.921875 C 11.992188 -8.417969 11.199219 -9.351563 9.328125 -9.71875 C 7.722656 -10.019531 6.777344 -9.425781 6.5 -7.9375 L 3.328125 -8.546875 C 3.566406 -9.816406 4.207031 -10.679688 5.25 -11.140625 C 6.289063 -11.605469 7.734375 -11.667969 9.578125 -11.328125 C 11.785156 -10.898438 13.285156 -10.269531 14.078125 -9.4375 C 14.867188 -8.625 15.136719 -7.582031 14.890625 -6.3125 L 13.671875 0.109375 C 13.503906 0.941406 13.136719 1.515625 12.578125 1.828125 C 12.054688 2.117188 11.382813 2.179688 10.5625 2.015625 C 9.726563 1.859375 9.113281 1.585938 8.71875 1.203125 C 8.320313 0.828125 8.082031 0.261719 8 -0.484375 C 7.914063 -1.230469 7.738281 -1.835938 7.46875 -2.296875 C 7.195313 -2.753906 6.792969 -3.035156 6.265625 -3.140625 C 5.679688 -3.253906 5.320313 -3.105469 5.1875 -2.703125 C 5.882813 -2.566406 6.375 -2.324219 6.65625 -1.984375 C 6.914063 -1.671875 6.996094 -1.261719 6.90625 -0.765625 C 6.882813 -0.640625 6.863281 -0.519531 6.84375 -0.40625 C 6.75 0.0820313 6.527344 0.441406 6.1875 0.671875 Z M 6.1875 0.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph22-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph22-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.203125 -18.390625 C -3.128906 -18.480469 -3.082031 -18.570313 -3.0625 -18.65625 C -3.050781 -18.707031 -3.050781 -18.757813 -3.0625 -18.8125 C -3.113281 -18.988281 -3.222656 -19.097656 -3.390625 -19.140625 L -3.46875 -19.15625 C -3.621094 -19.15625 -3.726563 -19.058594 -3.78125 -18.875 C -3.789063 -18.863281 -3.796875 -18.851563 -3.796875 -18.84375 C -3.835938 -18.6875 -3.800781 -18.574219 -3.6875 -18.515625 C -3.59375 -18.472656 -3.488281 -18.433594 -3.375 -18.40625 C -3.320313 -18.394531 -3.261719 -18.390625 -3.203125 -18.390625 Z M -3.96875 -17.84375 C -4.332031 -17.976563 -4.601563 -18.148438 -4.78125 -18.359375 C -4.964844 -18.597656 -5.023438 -18.863281 -4.953125 -19.15625 L -4.9375 -19.25 C -4.832031 -19.589844 -4.589844 -19.820313 -4.21875 -19.9375 C -3.914063 -20.027344 -3.589844 -20.035156 -3.25 -19.953125 C -3.175781 -19.929688 -3.097656 -19.902344 -3.015625 -19.875 C -2.140625 -19.625 -1.660156 -19.347656 -1.578125 -19.046875 C -1.484375 -18.765625 -1.476563 -18.449219 -1.5625 -18.109375 L -1.59375 -18.015625 C -1.695313 -17.628906 -2.101563 -17.226563 -2.8125 -16.8125 C -2.21875 -16.75 -1.632813 -16.878906 -1.0625 -17.203125 C -0.5 -17.523438 0.0234375 -18.019531 0.515625 -18.6875 L 2.671875 -17.546875 C 2.023438 -16.859375 1.433594 -16.382813 0.90625 -16.125 C 0.375 -15.875 -0.25 -15.707031 -0.96875 -15.625 C -1.695313 -15.550781 -2.75 -15.6875 -4.125 -16.03125 L -6.453125 -16.59375 L -6.234375 -17.484375 C -5.203125 -17.421875 -4.445313 -17.539063 -3.96875 -17.84375 Z M -3.96875 -17.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph23-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph23-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3 2.296875 C 2.820313 2.242188 2.648438 2.28125 2.484375 2.40625 C 2.367188 2.496094 2.277344 2.65625 2.21875 2.875 C 2.207031 2.914063 2.203125 2.957031 2.203125 3 C 2.109375 3.394531 2.320313 3.722656 2.84375 3.984375 C 3.132813 3.878906 3.328125 3.667969 3.421875 3.359375 L 3.421875 3.34375 C 3.492188 3.070313 3.488281 2.839844 3.40625 2.65625 C 3.332031 2.46875 3.195313 2.347656 3 2.296875 Z M 7.375 6 C 6.582031 6.445313 5.617188 6.507813 4.484375 6.1875 C 3.566406 5.925781 2.855469 5.679688 2.359375 5.453125 C 1.867188 5.222656 1.425781 4.945313 1.03125 4.625 C 0.632813 4.300781 0.371094 3.964844 0.25 3.625 C 0.125 3.289063 0.128906 2.882813 0.265625 2.40625 L 0.296875 2.34375 C 0.441406 1.820313 0.765625 1.425781 1.265625 1.15625 C 1.761719 0.882813 2.238281 0.789063 2.6875 0.875 C 2.820313 0.894531 2.941406 0.921875 3.046875 0.953125 C 3.324219 1.035156 3.554688 1.140625 3.734375 1.265625 C 3.972656 1.429688 4.175781 1.628906 4.34375 1.859375 C 4.507813 2.085938 4.617188 2.378906 4.671875 2.734375 C 4.710938 2.980469 4.695313 3.25 4.625 3.53125 C 4.59375 3.621094 4.554688 3.726563 4.515625 3.84375 C 4.335938 4.226563 4.132813 4.472656 3.90625 4.578125 C 4.964844 4.878906 5.800781 3.980469 6.40625 1.890625 L 8.359375 -4.921875 C 8.535156 -5.535156 7.808594 -6.492188 6.1875 -7.796875 C 4.5625 -9.105469 3.835938 -10.066406 4.015625 -10.671875 C 4.128906 -11.066406 4.316406 -11.34375 4.578125 -11.5 C 4.824219 -11.664063 5.085938 -11.753906 5.359375 -11.765625 C 5.617188 -11.785156 5.953125 -11.738281 6.359375 -11.625 C 6.742188 -11.507813 7.320313 -11.191406 8.09375 -10.671875 C 8.863281 -10.148438 9.328125 -9.867188 9.484375 -9.828125 C 9.648438 -9.785156 9.8125 -10.035156 9.96875 -10.578125 L 13.078125 -9.6875 L 12.90625 -9.109375 C 12.789063 -8.691406 12.582031 -8.363281 12.28125 -8.125 C 12 -7.90625 11.679688 -7.800781 11.328125 -7.8125 C 11.148438 -7.820313 10.960938 -7.851563 10.765625 -7.90625 C 10.585938 -7.957031 10.394531 -8.03125 10.1875 -8.125 C 9.78125 -8.320313 9.351563 -8.566406 8.90625 -8.859375 C 8.46875 -9.136719 7.996094 -9.453125 7.5 -9.796875 C 6.988281 -10.105469 6.558594 -10.320313 6.21875 -10.4375 L 6.140625 -10.46875 C 5.847656 -10.550781 5.660156 -10.527344 5.578125 -10.40625 L 5.5625 -10.359375 C 5.53125 -10.222656 5.648438 -10.070313 5.921875 -9.90625 C 6.230469 -9.738281 6.628906 -9.511719 7.109375 -9.234375 C 7.574219 -8.953125 8.082031 -8.632813 8.625 -8.28125 C 9.175781 -7.925781 9.675781 -7.542969 10.125 -7.140625 C 10.558594 -6.742188 10.957031 -6.324219 11.3125 -5.890625 C 11.644531 -5.472656 11.757813 -5.070313 11.65625 -4.6875 L 9.53125 2.71875 C 9.0625 4.363281 8.339844 5.457031 7.375 6 Z M 7.375 6 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph24-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph24-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.546875 -8.609375 C 5.359375 -8.085938 5.53125 -7.726563 6.0625 -7.53125 C 6.589844 -7.332031 6.953125 -7.492188 7.140625 -8.015625 C 7.347656 -8.554688 7.183594 -8.925781 6.65625 -9.125 C 6.125 -9.320313 5.753906 -9.148438 5.546875 -8.609375 Z M 6.453125 6.046875 C 5.390625 6.410156 3.773438 6.191406 1.609375 5.390625 C 0.828125 5.109375 0.0820313 4.753906 -0.625 4.328125 L -0.0625 2.8125 C 0.644531 3.238281 1.390625 3.59375 2.171875 3.875 C 2.949219 4.164063 3.628906 4.210938 4.203125 4.015625 C 4.917969 3.773438 5.460938 3.152344 5.828125 2.15625 L 8.828125 -5.953125 C 9.386719 -7.472656 9.210938 -8.507813 8.296875 -9.0625 C 8.542969 -8.601563 8.566406 -8.101563 8.359375 -7.5625 C 7.867188 -6.226563 6.949219 -5.8125 5.609375 -6.3125 C 4.265625 -6.800781 3.835938 -7.710938 4.328125 -9.046875 C 5.003906 -10.867188 6.519531 -11.347656 8.875 -10.484375 C 11.851563 -9.378906 12.847656 -7.492188 11.859375 -4.828125 L 8.859375 3.28125 C 8.316406 4.757813 7.511719 5.679688 6.453125 6.046875 Z M 6.453125 6.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph25-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph25-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.609375 1.15625 C 5.085938 1.382813 5.441406 1.257813 5.671875 0.78125 C 5.886719 0.3125 5.757813 -0.0351563 5.28125 -0.265625 C 4.8125 -0.492188 4.464844 -0.371094 4.25 0.09375 C 4.019531 0.570313 4.140625 0.925781 4.609375 1.15625 Z M 5.828125 2.1875 C 5.347656 2.332031 4.746094 2.238281 4.03125 1.90625 C 3.195313 1.488281 2.675781 0.964844 2.46875 0.34375 C 2.25 -0.308594 2.347656 -1.078125 2.765625 -1.953125 C 3.304688 -3.097656 3.953125 -3.785156 4.703125 -4.015625 C 5.472656 -4.242188 6.503906 -4.050781 7.796875 -3.4375 C 8.566406 -3.070313 9.050781 -2.449219 9.25 -1.578125 C 9.457031 -0.703125 9.511719 0.210938 9.421875 1.171875 C 9.335938 2.128906 9.398438 2.65625 9.609375 2.75 C 9.816406 2.851563 10.039063 2.648438 10.28125 2.140625 L 13.078125 -3.75 C 13.730469 -5.132813 13.195313 -6.238281 11.46875 -7.0625 C 10 -7.757813 8.933594 -7.417969 8.28125 -6.046875 L 5.359375 -7.4375 C 5.917969 -8.613281 6.753906 -9.289063 7.859375 -9.46875 C 8.992188 -9.664063 10.40625 -9.363281 12.09375 -8.5625 C 14.121094 -7.59375 15.425781 -6.605469 16 -5.609375 C 16.550781 -4.628906 16.550781 -3.550781 16 -2.375 L 13.203125 3.515625 C 12.835938 4.285156 12.347656 4.753906 11.734375 4.921875 C 11.148438 5.066406 10.476563 4.960938 9.71875 4.609375 C 8.945313 4.242188 8.414063 3.824219 8.125 3.359375 C 7.832031 2.890625 7.738281 2.277344 7.84375 1.53125 C 7.957031 0.78125 7.941406 0.148438 7.796875 -0.359375 C 7.660156 -0.867188 7.347656 -1.238281 6.859375 -1.46875 C 6.316406 -1.726563 5.925781 -1.675781 5.6875 -1.3125 C 6.320313 -1.007813 6.738281 -0.652344 6.9375 -0.25 C 7.113281 0.113281 7.089844 0.53125 6.875 1 C 6.832031 1.113281 6.785156 1.222656 6.734375 1.328125 C 6.523438 1.785156 6.222656 2.070313 5.828125 2.1875 Z M 5.828125 2.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph26-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph26-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -6.9375 -1.96875 C -7.007813 -1.96875 -7.078125 -1.949219 -7.140625 -1.921875 C -7.199219 -1.890625 -7.25 -1.835938 -7.28125 -1.765625 C -7.320313 -1.691406 -7.335938 -1.617188 -7.328125 -1.546875 C -7.328125 -1.484375 -7.308594 -1.425781 -7.28125 -1.375 C -7.257813 -1.320313 -7.164063 -1.238281 -7 -1.125 C -6.832031 -1.207031 -6.714844 -1.304688 -6.65625 -1.421875 C -6.625 -1.492188 -6.609375 -1.566406 -6.609375 -1.640625 C -6.609375 -1.710938 -6.625 -1.773438 -6.65625 -1.828125 C -6.683594 -1.878906 -6.722656 -1.921875 -6.765625 -1.953125 C -6.816406 -1.972656 -6.875 -1.976563 -6.9375 -1.96875 Z M -5.8125 -0.140625 C -5.988281 0.0234375 -6.125 0.203125 -6.21875 0.390625 C -6.269531 0.472656 -6.304688 0.550781 -6.328125 0.625 C -6.355469 0.777344 -6.253906 0.925781 -6.015625 1.0625 C -5.703125 1.226563 -5.335938 0.929688 -4.921875 0.171875 L -4.078125 -1.40625 L -2.46875 -0.546875 L -3.34375 1.078125 C -4.027344 2.355469 -5.066406 2.628906 -6.453125 1.890625 C -7.472656 1.335938 -7.976563 0.839844 -7.96875 0.40625 C -7.976563 0.144531 -7.933594 -0.0703125 -7.84375 -0.25 C -7.757813 -0.394531 -7.648438 -0.503906 -7.515625 -0.578125 C -7.699219 -0.679688 -7.863281 -0.828125 -8 -1.015625 C -8.121094 -1.199219 -8.1875 -1.398438 -8.1875 -1.609375 C -8.1875 -1.824219 -8.132813 -2.023438 -8.03125 -2.203125 C -7.9375 -2.386719 -7.800781 -2.539063 -7.625 -2.65625 C -7.445313 -2.777344 -7.242188 -2.832031 -7.015625 -2.8125 C -6.785156 -2.800781 -6.441406 -2.675781 -5.984375 -2.4375 C -5.710938 -2.289063 -5.507813 -2.121094 -5.375 -1.9375 C -5.25 -1.757813 -5.179688 -1.558594 -5.171875 -1.34375 C -5.160156 -1.125 -5.203125 -0.917969 -5.296875 -0.734375 C -5.386719 -0.566406 -5.5625 -0.367188 -5.8125 -0.140625 Z M -5.8125 -0.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph27-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph27-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3 -0.671875 C 2.707031 -0.191406 2.800781 0.191406 3.28125 0.484375 C 3.769531 0.773438 4.160156 0.679688 4.453125 0.203125 C 4.753906 -0.285156 4.660156 -0.675781 4.171875 -0.96875 C 3.691406 -1.257813 3.300781 -1.160156 3 -0.671875 Z M 8.46875 -6.59375 L 8.609375 -6.828125 C 9.066406 -7.585938 9.070313 -8.109375 8.625 -8.390625 C 8.164063 -8.660156 7.800781 -8.566406 7.53125 -8.109375 C 7.25 -7.648438 7.472656 -7.199219 8.203125 -6.765625 C 8.292969 -6.703125 8.382813 -6.644531 8.46875 -6.59375 Z M 5.6875 2.6875 C 5.050781 2.808594 4.023438 2.445313 2.609375 1.59375 C 1.960938 1.195313 1.589844 0.730469 1.5 0.203125 C 1.414063 -0.253906 1.546875 -0.769531 1.890625 -1.34375 C 2.242188 -1.925781 2.648438 -2.289063 3.109375 -2.4375 C 3.628906 -2.589844 4.207031 -2.472656 4.84375 -2.078125 C 5.089844 -1.929688 5.289063 -1.777344 5.4375 -1.625 L 7.796875 -5.5 L 7.546875 -5.65625 C 6.753906 -6.132813 6.277344 -6.660156 6.125 -7.234375 C 5.976563 -7.710938 6.078125 -8.226563 6.421875 -8.78125 C 6.773438 -9.371094 7.203125 -9.722656 7.703125 -9.828125 C 8.191406 -9.941406 8.734375 -9.816406 9.328125 -9.453125 C 11.261719 -8.273438 12.085938 -7.148438 11.796875 -6.078125 C 13.066406 -6.554688 14.316406 -6.425781 15.546875 -5.6875 C 16.585938 -5.050781 17.253906 -4.339844 17.546875 -3.5625 C 17.929688 -2.632813 17.785156 -1.613281 17.109375 -0.5 L 12.265625 7.46875 L 9.5 5.78125 L 14.34375 -2.1875 C 14.683594 -2.757813 14.777344 -3.285156 14.625 -3.765625 C 14.46875 -4.242188 14.183594 -4.601563 13.78125 -4.84375 C 13.363281 -5.101563 12.601563 -5.027344 11.5 -4.625 L 10.890625 -4.359375 L 7.53125 1.15625 C 7 2.039063 6.382813 2.550781 5.6875 2.6875 Z M 5.6875 2.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph28-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph28-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.265625 1.578125 C 8.335938 2.066406 8.152344 2.597656 7.71875 3.171875 C 7.28125 3.742188 6.816406 4.066406 6.328125 4.140625 C 5.828125 4.199219 5.167969 3.929688 4.359375 3.328125 C 3.523438 2.679688 2.996094 2.039063 2.78125 1.40625 C 2.476563 0.5 2.71875 -0.46875 3.5 -1.5 L 6.734375 -5.734375 C 8.460938 -8.003906 10.890625 -7.945313 14.015625 -5.5625 C 17.136719 -3.1875 17.835938 -0.863281 16.109375 1.40625 L 10.875 8.28125 L 8.3125 6.3125 L 13.546875 -0.5625 C 14.617188 -1.964844 14.445313 -3.203125 13.03125 -4.265625 C 11.625 -5.335938 10.382813 -5.167969 9.3125 -3.765625 L 6.46875 -0.03125 C 6.882813 -0.0078125 7.273438 0.132813 7.640625 0.40625 C 8.003906 0.675781 8.210938 1.066406 8.265625 1.578125 Z M 6.171875 2.84375 C 6.386719 2.832031 6.59375 2.707031 6.78125 2.46875 C 6.945313 2.25 7.019531 2.039063 7 1.84375 C 6.976563 1.632813 6.851563 1.441406 6.625 1.265625 C 6.164063 0.921875 5.761719 0.976563 5.421875 1.4375 C 5.222656 1.695313 5.160156 1.945313 5.234375 2.1875 C 5.285156 2.332031 5.40625 2.476563 5.59375 2.625 C 5.789063 2.777344 5.984375 2.851563 6.171875 2.84375 Z M 6.171875 2.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph29-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph29-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.3125 -17.890625 C 5.425781 -17.941406 5.507813 -18.003906 5.5625 -18.078125 C 5.589844 -18.105469 5.609375 -18.15625 5.609375 -18.21875 C 5.660156 -18.394531 5.621094 -18.535156 5.5 -18.640625 L 5.4375 -18.703125 C 5.28125 -18.761719 5.136719 -18.726563 5.015625 -18.59375 C 4.992188 -18.582031 4.976563 -18.570313 4.96875 -18.5625 C 4.863281 -18.4375 4.847656 -18.324219 4.921875 -18.234375 C 4.992188 -18.140625 5.078125 -18.054688 5.171875 -17.984375 C 5.199219 -17.953125 5.25 -17.917969 5.3125 -17.890625 Z M 4.390625 -17.75 C 4.117188 -18.027344 3.949219 -18.300781 3.890625 -18.5625 C 3.828125 -18.863281 3.894531 -19.128906 4.09375 -19.359375 L 4.15625 -19.421875 C 4.402344 -19.679688 4.71875 -19.785156 5.09375 -19.734375 C 5.402344 -19.679688 5.695313 -19.539063 5.96875 -19.3125 C 6.019531 -19.257813 6.078125 -19.199219 6.140625 -19.140625 C 6.804688 -18.523438 7.113281 -18.058594 7.0625 -17.75 C 7.019531 -17.46875 6.882813 -17.191406 6.65625 -16.921875 L 6.578125 -16.84375 C 6.316406 -16.539063 5.777344 -16.355469 4.96875 -16.296875 C 5.457031 -15.984375 6.03125 -15.84375 6.6875 -15.875 C 7.339844 -15.914063 8.035156 -16.125 8.765625 -16.5 L 10.1875 -14.515625 C 9.3125 -14.203125 8.574219 -14.046875 7.984375 -14.046875 C 7.398438 -14.054688 6.761719 -14.1875 6.078125 -14.4375 C 5.398438 -14.695313 4.519531 -15.28125 3.4375 -16.1875 L 1.59375 -17.75 L 2.1875 -18.4375 C 3.082031 -17.925781 3.816406 -17.695313 4.390625 -17.75 Z M 4.390625 -17.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph30-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph30-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.703125 -0.59375 C 6.554688 -0.621094 6.410156 -0.617188 6.265625 -0.578125 C 6.128906 -0.535156 6.003906 -0.457031 5.890625 -0.34375 C 5.796875 -0.226563 5.726563 -0.0976563 5.6875 0.046875 C 5.644531 0.199219 5.644531 0.347656 5.6875 0.484375 C 5.726563 0.628906 5.804688 0.753906 5.921875 0.859375 C 6.035156 0.949219 6.164063 1.019531 6.3125 1.0625 C 6.464844 1.101563 6.617188 1.097656 6.765625 1.046875 C 6.910156 1.003906 7.03125 0.925781 7.125 0.8125 C 7.238281 0.695313 7.3125 0.566406 7.34375 0.421875 C 7.371094 0.273438 7.363281 0.128906 7.3125 -0.015625 C 7.269531 -0.167969 7.195313 -0.296875 7.09375 -0.390625 C 6.988281 -0.492188 6.855469 -0.5625 6.703125 -0.59375 Z M 7.1875 -5.28125 C 9.070313 -7.308594 11.453125 -6.980469 14.328125 -4.296875 C 17.199219 -1.617188 17.664063 0.765625 15.71875 2.859375 L 12.734375 6.046875 C 11.765625 7.085938 10.695313 7.550781 9.53125 7.4375 C 8.363281 7.320313 7.023438 6.558594 5.515625 5.15625 C 4.003906 3.738281 3.148438 2.449219 2.953125 1.296875 C 2.753906 0.140625 3.140625 -0.957031 4.109375 -2 C 4.367188 -2.269531 4.6875 -2.460938 5.0625 -2.578125 C 5.433594 -2.699219 5.828125 -2.699219 6.234375 -2.578125 C 6.636719 -2.453125 7.21875 -2.035156 7.96875 -1.328125 C 8.226563 -1.085938 8.421875 -0.777344 8.546875 -0.40625 C 8.667969 -0.0390625 8.683594 0.328125 8.59375 0.703125 C 8.5 1.085938 8.320313 1.414063 8.0625 1.6875 C 7.8125 1.964844 7.496094 2.164063 7.125 2.28125 C 6.757813 2.402344 6.394531 2.417969 6.03125 2.328125 C 5.8125 2.273438 5.605469 2.191406 5.421875 2.078125 C 5.730469 2.867188 6.132813 3.5 6.625 3.96875 C 7.914063 5.175781 9.160156 5.132813 10.359375 3.84375 L 13.34375 0.65625 C 14.550781 -0.644531 14.507813 -1.898438 13.21875 -3.109375 C 11.925781 -4.316406 10.707031 -4.300781 9.5625 -3.0625 Z M 7.1875 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph31-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph31-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.703125 -0.5625 C 11.203125 -0.589844 10.800781 -0.773438 10.5 -1.109375 C 10.195313 -1.449219 10.011719 -1.832031 9.953125 -2.25 L 9.546875 -1.875 C 8.847656 -1.257813 8.898438 -0.496094 9.703125 0.40625 L 9.921875 0.671875 C 10.167969 0.949219 10.101563 1.257813 9.71875 1.59375 C 9.34375 1.925781 9.027344 1.949219 8.78125 1.671875 L 8.5625 1.40625 C 7.757813 0.5 6.878906 0.460938 5.921875 1.296875 C 5.410156 1.742188 5.160156 2.21875 5.171875 2.71875 C 5.191406 3.214844 5.570313 3.882813 6.3125 4.71875 C 6.863281 5.339844 7.425781 5.675781 8 5.71875 C 8.582031 5.769531 9.226563 5.480469 9.9375 4.859375 L 16.453125 -0.84375 L 18.578125 1.578125 L 12.0625 7.28125 C 10.976563 8.238281 9.855469 8.589844 8.703125 8.34375 C 7.554688 8.09375 6.351563 7.242188 5.09375 5.796875 C 3.632813 4.140625 2.832031 2.746094 2.6875 1.625 C 2.539063 0.570313 2.910156 -0.34375 3.796875 -1.125 C 4.773438 -1.976563 5.851563 -2.113281 7.03125 -1.53125 C 6.632813 -2.800781 6.765625 -3.722656 7.421875 -4.296875 L 8.3125 -5.09375 C 9.277344 -5.933594 10.21875 -6.238281 11.125 -6 C 11.800781 -5.832031 12.488281 -5.351563 13.1875 -4.5625 C 13.851563 -3.8125 14.160156 -3.191406 14.109375 -2.703125 C 14.078125 -2.179688 13.792969 -1.683594 13.265625 -1.21875 C 12.722656 -0.75 12.199219 -0.53125 11.703125 -0.5625 Z M 12.8125 -2.734375 C 12.800781 -2.910156 12.710938 -3.09375 12.546875 -3.28125 C 12.390625 -3.464844 12.238281 -3.582031 12.09375 -3.625 C 11.863281 -3.683594 11.617188 -3.601563 11.359375 -3.375 C 10.929688 -3.007813 10.90625 -2.605469 11.28125 -2.171875 C 11.476563 -1.953125 11.679688 -1.847656 11.890625 -1.859375 C 12.074219 -1.835938 12.273438 -1.914063 12.484375 -2.09375 C 12.710938 -2.300781 12.820313 -2.515625 12.8125 -2.734375 Z M 12.8125 -2.734375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph32-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph32-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.859375 -3.25 C 10.191406 -2.78125 10.585938 -2.707031 11.046875 -3.03125 C 11.503906 -3.351563 11.566406 -3.75 11.234375 -4.21875 C 10.910156 -4.675781 10.519531 -4.742188 10.0625 -4.421875 C 9.601563 -4.097656 9.535156 -3.707031 9.859375 -3.25 Z M 9.296875 -1.921875 C 9.128906 -2.066406 8.960938 -2.253906 8.796875 -2.484375 C 8.367188 -3.097656 8.21875 -3.671875 8.34375 -4.203125 C 8.445313 -4.667969 8.769531 -5.097656 9.3125 -5.484375 C 9.851563 -5.867188 10.367188 -6.035156 10.859375 -5.984375 C 11.378906 -5.941406 11.859375 -5.605469 12.296875 -4.984375 C 13.253906 -3.640625 13.695313 -2.644531 13.625 -2 C 13.53125 -1.28125 13.066406 -0.621094 12.234375 -0.03125 L 7.296875 3.46875 C 6.960938 3.707031 6.644531 3.894531 6.34375 4.03125 C 6.558594 4.402344 6.621094 4.894531 6.53125 5.5 C 6.488281 6.039063 6.660156 6.578125 7.046875 7.109375 C 7.523438 7.792969 8.300781 7.757813 9.375 7 L 16.96875 1.59375 L 18.84375 4.21875 L 11.25 9.625 C 9.289063 11.007813 7.488281 10.542969 5.84375 8.234375 C 5.1875 7.316406 4.96875 6.324219 5.1875 5.265625 C 5.246094 4.910156 5.214844 4.605469 5.09375 4.359375 C 3.820313 4.449219 2.441406 3.445313 0.953125 1.34375 L 2.28125 0.40625 C 2.695313 0.996094 3.164063 1.328125 3.6875 1.390625 C 4.207031 1.460938 4.785156 1.273438 5.421875 0.828125 Z M 9.296875 -1.921875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph33-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph33-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.703125 -14.28125 C 11.660156 -14.351563 11.582031 -14.40625 11.46875 -14.4375 C 11.363281 -14.464844 11.238281 -14.472656 11.09375 -14.453125 C 10.945313 -14.429688 10.808594 -14.378906 10.6875 -14.296875 C 10.539063 -14.210938 10.425781 -14.105469 10.34375 -13.984375 C 10.269531 -13.867188 10.222656 -13.753906 10.203125 -13.640625 C 10.179688 -13.523438 10.191406 -13.429688 10.234375 -13.359375 C 10.285156 -13.273438 10.367188 -13.214844 10.484375 -13.1875 C 10.605469 -13.15625 10.734375 -13.148438 10.859375 -13.171875 C 10.992188 -13.199219 11.132813 -13.257813 11.28125 -13.34375 C 11.402344 -13.425781 11.515625 -13.523438 11.609375 -13.640625 C 11.699219 -13.753906 11.753906 -13.867188 11.765625 -13.984375 C 11.773438 -14.097656 11.753906 -14.195313 11.703125 -14.28125 Z M 12.796875 -14.96875 C 13.023438 -14.613281 13.164063 -14.214844 13.21875 -13.78125 C 13.277344 -13.34375 13.226563 -12.929688 13.0625 -12.546875 C 12.894531 -12.171875 12.652344 -11.878906 12.34375 -11.671875 C 12.007813 -11.472656 11.636719 -11.375 11.234375 -11.375 C 10.828125 -11.375 10.429688 -11.492188 10.046875 -11.734375 C 9.671875 -11.972656 9.363281 -12.28125 9.125 -12.65625 C 8.894531 -13.019531 8.753906 -13.421875 8.703125 -13.859375 C 8.660156 -14.292969 8.722656 -14.703125 8.890625 -15.078125 C 9.054688 -15.449219 9.304688 -15.738281 9.640625 -15.9375 C 9.949219 -16.144531 10.316406 -16.242188 10.734375 -16.234375 C 11.148438 -16.222656 11.539063 -16.097656 11.90625 -15.859375 C 12.277344 -15.617188 12.578125 -15.320313 12.796875 -14.96875 Z M 14.75 -17.265625 C 14.863281 -17.273438 14.957031 -17.300781 15.03125 -17.34375 C 15.070313 -17.371094 15.109375 -17.414063 15.140625 -17.46875 C 15.222656 -17.632813 15.222656 -17.785156 15.140625 -17.921875 L 15.09375 -18 C 14.96875 -18.089844 14.824219 -18.089844 14.671875 -18 C 14.671875 -18 14.664063 -18 14.65625 -18 C 14.507813 -17.90625 14.457031 -17.804688 14.5 -17.703125 C 14.527344 -17.597656 14.578125 -17.496094 14.640625 -17.40625 C 14.660156 -17.363281 14.695313 -17.316406 14.75 -17.265625 Z M 13.859375 -17.40625 C 13.679688 -17.757813 13.601563 -18.070313 13.625 -18.34375 C 13.632813 -18.632813 13.765625 -18.859375 14.015625 -19.015625 L 14.09375 -19.0625 C 14.402344 -19.214844 14.738281 -19.214844 15.09375 -19.0625 C 15.351563 -18.90625 15.578125 -18.679688 15.765625 -18.390625 C 15.792969 -18.328125 15.835938 -18.257813 15.890625 -18.1875 C 16.324219 -17.394531 16.480469 -16.855469 16.359375 -16.578125 C 16.234375 -16.328125 16.023438 -16.105469 15.734375 -15.921875 L 15.65625 -15.875 C 15.320313 -15.675781 14.769531 -15.675781 14 -15.875 C 14.371094 -15.414063 14.875 -15.097656 15.5 -14.921875 C 16.132813 -14.753906 16.835938 -14.738281 17.609375 -14.875 L 18.375 -12.5625 C 17.46875 -12.53125 16.738281 -12.613281 16.1875 -12.8125 C 15.644531 -13.007813 15.089844 -13.332031 14.53125 -13.78125 C 13.976563 -14.226563 13.316406 -15.050781 12.546875 -16.25 L 11.265625 -18.28125 L 11.984375 -18.75 C 12.679688 -17.988281 13.304688 -17.539063 13.859375 -17.40625 Z M 13.859375 -17.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph34-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph34-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.46875 -1.875 C 9.988281 -1.601563 9.835938 -1.320313 10.015625 -1.03125 C 10.191406 -0.726563 10.519531 -0.710938 11 -0.984375 C 11.289063 -1.160156 11.347656 -1.398438 11.171875 -1.703125 C 10.992188 -1.992188 10.757813 -2.050781 10.46875 -1.875 Z M 3.203125 5.53125 L 10.671875 1.1875 C 11.441406 0.75 11.761719 0.394531 11.640625 0.125 C 10.398438 0.839844 9.414063 0.574219 8.6875 -0.671875 C 7.976563 -1.886719 8.242188 -2.859375 9.484375 -3.578125 C 11.160156 -4.554688 12.570313 -4.058594 13.71875 -2.09375 C 15.238281 0.527344 14.761719 2.554688 12.296875 3.984375 L 4.828125 8.328125 Z M 3.203125 5.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph35-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph35-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.28125 -1.390625 C 10.527344 -0.867188 10.910156 -0.726563 11.421875 -0.96875 C 11.929688 -1.195313 12.058594 -1.570313 11.8125 -2.09375 C 11.582031 -2.601563 11.210938 -2.742188 10.703125 -2.515625 C 10.191406 -2.273438 10.050781 -1.898438 10.28125 -1.390625 Z M 9.5 -0.203125 C 9.363281 -0.378906 9.230469 -0.59375 9.109375 -0.84375 C 8.796875 -1.519531 8.742188 -2.109375 8.953125 -2.609375 C 9.148438 -3.042969 9.550781 -3.40625 10.15625 -3.6875 C 10.757813 -3.964844 11.289063 -4.039063 11.75 -3.90625 C 12.269531 -3.757813 12.6875 -3.339844 13 -2.65625 C 13.695313 -1.15625 13.945313 -0.0976563 13.75 0.515625 C 13.539063 1.199219 12.972656 1.757813 12.046875 2.1875 L 6.546875 4.734375 C 6.171875 4.898438 5.816406 5.03125 5.484375 5.125 C 5.636719 5.527344 5.613281 6.015625 5.40625 6.578125 C 5.269531 7.105469 5.34375 7.671875 5.625 8.265625 C 5.964844 9.023438 6.738281 9.128906 7.9375 8.578125 L 16.390625 4.65625 L 17.75 7.59375 L 9.296875 11.515625 C 7.117188 12.523438 5.433594 11.738281 4.25 9.15625 C 3.769531 8.132813 3.734375 7.121094 4.140625 6.125 C 4.273438 5.789063 4.292969 5.480469 4.203125 5.203125 C 2.941406 5.066406 1.773438 3.832031 0.703125 1.5 L 2.171875 0.8125 C 2.472656 1.464844 2.875 1.875 3.375 2.03125 C 3.871094 2.195313 4.476563 2.117188 5.1875 1.796875 Z M 9.5 -0.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph36-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph36-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.65625 -13.6875 C 10.707031 -13.570313 10.785156 -13.472656 10.890625 -13.390625 C 11.003906 -13.304688 11.125 -13.246094 11.25 -13.21875 C 11.382813 -13.195313 11.507813 -13.210938 11.625 -13.265625 C 11.738281 -13.304688 11.835938 -13.378906 11.921875 -13.484375 C 12.011719 -13.597656 12.066406 -13.722656 12.078125 -13.859375 C 12.085938 -13.992188 12.066406 -14.117188 12.015625 -14.234375 C 11.972656 -14.347656 11.898438 -14.445313 11.796875 -14.53125 C 11.703125 -14.621094 11.585938 -14.675781 11.453125 -14.6875 C 11.316406 -14.695313 11.191406 -14.679688 11.078125 -14.640625 C 10.960938 -14.585938 10.863281 -14.507813 10.78125 -14.40625 C 10.695313 -14.3125 10.644531 -14.191406 10.625 -14.046875 C 10.601563 -13.910156 10.613281 -13.789063 10.65625 -13.6875 Z M 12.765625 -12.84375 C 12.554688 -12.59375 12.304688 -12.410156 12.015625 -12.296875 C 11.722656 -12.171875 11.410156 -12.128906 11.078125 -12.171875 C 10.753906 -12.222656 10.464844 -12.351563 10.21875 -12.5625 C 9.96875 -12.769531 9.785156 -13.015625 9.671875 -13.296875 C 9.421875 -13.917969 9.316406 -14.394531 9.359375 -14.71875 C 9.398438 -15.039063 9.519531 -15.328125 9.71875 -15.578125 C 9.925781 -15.835938 10.175781 -16.03125 10.46875 -16.15625 C 11.425781 -16.527344 12.300781 -16.414063 13.09375 -15.8125 C 13.882813 -15.207031 14.519531 -14.308594 15 -13.125 C 15.570313 -11.695313 15.730469 -10.316406 15.484375 -8.984375 C 15.234375 -7.648438 14.378906 -6.582031 12.921875 -5.78125 L 11.71875 -8.796875 C 12.714844 -9.316406 13.367188 -9.851563 13.671875 -10.40625 C 13.972656 -10.964844 14.019531 -11.507813 13.8125 -12.03125 C 13.582031 -12.621094 13.230469 -12.894531 12.765625 -12.84375 Z M 12.765625 -12.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph37-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph37-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.5625 2.015625 C 2.707031 2.441406 3 2.582031 3.4375 2.4375 C 3.863281 2.289063 4.003906 2.003906 3.859375 1.578125 C 3.710938 1.140625 3.425781 0.992188 3 1.140625 C 2.5625 1.285156 2.414063 1.578125 2.5625 2.015625 Z M 6 5.40625 C 5.613281 5.539063 5.246094 5.628906 4.90625 5.671875 C 5.019531 6.097656 4.945313 6.582031 4.6875 7.125 C 4.488281 7.644531 4.492188 8.21875 4.703125 8.84375 C 4.972656 9.621094 5.734375 9.800781 6.984375 9.375 L 15.8125 6.375 L 16.84375 9.4375 L 8.015625 12.4375 C 5.742188 13.207031 4.148438 12.246094 3.234375 9.5625 C 2.878906 8.5 2.957031 7.488281 3.46875 6.53125 C 3.632813 6.21875 3.683594 5.917969 3.625 5.640625 C 2.382813 5.359375 1.582031 4.667969 1.21875 3.578125 C 0.601563 1.773438 1.078125 0.605469 2.640625 0.078125 C 3.785156 -0.304688 4.550781 0.0703125 4.9375 1.21875 C 5.082031 1.632813 5.117188 2 5.046875 2.3125 L 13.453125 -0.546875 L 14.5 2.515625 Z M 6 5.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph38-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph38-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.296875 12.921875 C 5.234375 12.847656 5.148438 12.792969 5.046875 12.765625 C 4.953125 12.742188 4.851563 12.742188 4.75 12.765625 C 4.65625 12.785156 4.570313 12.828125 4.5 12.890625 C 4.425781 12.949219 4.371094 13.03125 4.34375 13.125 C 4.3125 13.226563 4.304688 13.328125 4.328125 13.421875 C 4.347656 13.523438 4.390625 13.609375 4.453125 13.671875 C 4.523438 13.742188 4.609375 13.796875 4.703125 13.828125 C 4.792969 13.855469 4.890625 13.863281 4.984375 13.84375 C 5.085938 13.820313 5.175781 13.773438 5.25 13.703125 C 5.332031 13.628906 5.382813 13.542969 5.40625 13.453125 C 5.433594 13.367188 5.441406 13.273438 5.421875 13.171875 C 5.398438 13.078125 5.355469 12.992188 5.296875 12.921875 Z M 6.21875 12.296875 C 6.371094 12.492188 6.476563 12.707031 6.53125 12.9375 C 6.589844 13.214844 6.574219 13.503906 6.484375 13.796875 C 6.390625 14.085938 6.226563 14.335938 6 14.546875 C 5.78125 14.753906 5.523438 14.890625 5.234375 14.953125 C 4.640625 15.074219 4.144531 15.011719 3.75 14.765625 C 3.351563 14.515625 3.082031 14.054688 2.9375 13.390625 C 2.6875 12.253906 2.753906 11.339844 3.140625 10.65625 C 3.554688 9.90625 4.332031 9.402344 5.46875 9.15625 L 11.5 7.828125 C 12.644531 7.578125 13.5625 7.707031 14.25 8.21875 C 14.871094 8.675781 15.304688 9.457031 15.546875 10.5625 C 15.691406 11.195313 15.726563 11.894531 15.65625 12.65625 L 14.09375 13 C 14.175781 12.382813 14.183594 11.941406 14.125 11.671875 C 14.039063 11.304688 13.847656 11.066406 13.546875 10.953125 C 13.253906 10.835938 12.800781 10.847656 12.1875 10.984375 Z M 3.53125 4.890625 C 3.46875 4.816406 3.382813 4.761719 3.28125 4.734375 C 3.1875 4.703125 3.085938 4.695313 2.984375 4.71875 C 2.890625 4.738281 2.804688 4.78125 2.734375 4.84375 C 2.660156 4.914063 2.605469 5.003906 2.578125 5.109375 C 2.546875 5.210938 2.539063 5.304688 2.5625 5.390625 C 2.582031 5.492188 2.628906 5.582031 2.703125 5.65625 C 2.773438 5.726563 2.851563 5.78125 2.9375 5.8125 C 3.027344 5.839844 3.125 5.847656 3.21875 5.828125 C 3.320313 5.804688 3.410156 5.757813 3.484375 5.6875 C 3.566406 5.613281 3.617188 5.527344 3.640625 5.4375 C 3.667969 5.34375 3.675781 5.242188 3.65625 5.140625 C 3.632813 5.054688 3.589844 4.972656 3.53125 4.890625 Z M 4.453125 4.265625 C 4.605469 4.460938 4.710938 4.675781 4.765625 4.90625 C 4.824219 5.195313 4.808594 5.488281 4.71875 5.78125 C 4.632813 6.070313 4.476563 6.316406 4.25 6.515625 C 4.019531 6.722656 3.757813 6.859375 3.46875 6.921875 C 2.875 7.042969 2.378906 6.988281 1.984375 6.75 C 1.585938 6.488281 1.316406 6.023438 1.171875 5.359375 C 0.921875 4.222656 0.988281 3.308594 1.375 2.625 C 1.789063 1.875 2.566406 1.371094 3.703125 1.125 L 9.734375 -0.203125 C 10.878906 -0.449219 11.796875 -0.320313 12.484375 0.1875 C 13.105469 0.644531 13.539063 1.421875 13.78125 2.515625 C 13.925781 3.160156 13.960938 3.863281 13.890625 4.625 L 12.328125 4.96875 C 12.410156 4.351563 12.417969 3.910156 12.359375 3.640625 C 12.285156 3.285156 12.097656 3.042969 11.796875 2.921875 C 11.492188 2.804688 11.035156 2.816406 10.421875 2.953125 Z M 4.453125 4.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph39-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph39-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.046875 2.53125 C 2.097656 2.988281 2.351563 3.191406 2.8125 3.140625 C 3.269531 3.097656 3.472656 2.847656 3.421875 2.390625 C 3.378906 1.929688 3.128906 1.722656 2.671875 1.765625 C 2.210938 1.816406 2.003906 2.070313 2.046875 2.53125 Z M 4.671875 6.578125 C 4.265625 6.628906 3.886719 6.644531 3.546875 6.625 C 3.554688 7.050781 3.371094 7.503906 3 7.984375 C 2.695313 8.441406 2.582031 8.992188 2.65625 9.640625 C 2.738281 10.472656 3.4375 10.820313 4.75 10.6875 L 14.015625 9.703125 L 14.359375 12.921875 L 5.09375 13.90625 C 2.707031 14.152344 1.363281 12.863281 1.0625 10.03125 C 0.945313 8.914063 1.242188 7.945313 1.953125 7.125 C 2.179688 6.851563 2.296875 6.574219 2.296875 6.296875 C 1.148438 5.753906 0.519531 4.910156 0.40625 3.765625 C 0.195313 1.867188 0.910156 0.832031 2.546875 0.65625 C 3.753906 0.53125 4.421875 1.066406 4.546875 2.265625 C 4.597656 2.699219 4.558594 3.070313 4.4375 3.375 L 13.25 2.4375 L 13.59375 5.640625 Z M 4.671875 6.578125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph40-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph40-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 17.0625 -8.078125 L 17.171875 -5.921875 L 13.75 -5.75 L 13.640625 -7.90625 Z M 17.0625 -8.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph41-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 5.03125 11.4375 L 21.046875 4.390625 L 16.015625 -7.046875 Z M 11.546875 1.734375 L 15.6875 -4.71875 L 19.109375 3.0625 Z M 10.828125 2.875 L 18.375 4.203125 L 6.703125 9.34375 Z M 1.953125 1.328125 L 9.5 2.640625 L 5.375 9.109375 Z M 14.34375 -4.953125 L 10.234375 1.5 L 2.671875 0.1875 Z M 14.34375 -4.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph41-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.828125 1.875 L 3.953125 9 C 5.4375 12.359375 8.375 13.5625 11.078125 12.375 C 13.15625 11.46875 13.671875 9.59375 13.59375 8.359375 C 14.53125 9.21875 16.125 9.65625 17.90625 8.859375 C 19.9375 7.96875 21.296875 5.625 19.625 1.828125 L 16.59375 -5.0625 Z M 9.203125 2.171875 L 10.546875 5.234375 C 11.375 7.109375 10.921875 8.296875 9.65625 8.859375 C 8.21875 9.5 7.09375 8.984375 6.265625 7.125 L 4.921875 4.0625 Z M 11.828125 1.015625 L 15.421875 -0.5625 L 16.859375 2.6875 C 17.4375 4.015625 17.25 5.15625 16.078125 5.671875 C 14.96875 6.15625 13.9375 5.796875 13.21875 4.171875 Z M 11.828125 1.015625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph42-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 6.078125 10.921875 L 21.375 2.421875 L 15.296875 -8.5 Z M 11.65625 0.671875 L 15.171875 -6.140625 L 19.296875 1.28125 Z M 11.046875 1.875 L 18.6875 2.484375 L 7.546875 8.671875 Z M 2.0625 1.140625 L 9.703125 1.765625 L 6.1875 8.5625 Z M 13.828125 -6.25 L 10.3125 0.5625 L 2.6875 -0.0625 Z M 13.828125 -6.25 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph42-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.78125 1.390625 L 2.515625 4.515625 L 7.4375 1.78125 C 10.53125 0.0625 11.890625 1.078125 13.09375 3.390625 L 16.078125 1.734375 C 15.015625 -0.1875 13.390625 -0.859375 11.828125 -0.65625 C 12.4375 -1 13.546875 -1.65625 13.765625 -1.84375 L 12.0625 -4.90625 C 11.140625 -4.359375 10.140625 -3.8125 9.015625 -3.1875 Z M 0.78125 1.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph43-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 6.953125 10.390625 L 21.5 0.65625 L 14.546875 -9.734375 Z M 11.671875 -0.3125 L 14.609375 -7.375 L 19.34375 -0.3125 Z M 11.15625 0.953125 L 18.8125 0.9375 L 8.21875 8.015625 Z M 2.140625 0.96875 L 9.8125 0.953125 L 6.875 8.03125 Z M 13.25 -7.375 L 10.328125 -0.28125 L 2.65625 -0.296875 Z M 13.25 -7.375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph43-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.953125 7.609375 C 12.28125 7.46875 12.515625 7.296875 12.890625 7.0625 C 15.59375 5.25 17.390625 2.21875 14.921875 -1.484375 C 12.609375 -4.9375 9.046875 -5.046875 5.6875 -2.796875 C 2.859375 -0.890625 1.25 2.421875 3.625 5.953125 C 5.890625 9.34375 8.8125 9.046875 10.390625 8.5625 L 8.390625 5.5625 C 7.5625 5.71875 6.828125 5.703125 6 4.46875 C 5 2.96875 5.875 1.4375 7.21875 0.53125 Z M 9.078125 -0.625 C 10.46875 -1.390625 11.84375 -1.5 12.8125 -0.0625 C 13.78125 1.40625 13.046875 2.59375 11.828125 3.46875 Z M 9.078125 -0.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph44-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 7.921875 9.671875 L 21.453125 -1.421875 L 13.53125 -11.09375 Z M 11.59375 -1.421875 L 13.84375 -8.75 L 19.234375 -2.171875 Z M 11.203125 -0.125 L 18.828125 -0.875 L 8.96875 7.203125 Z M 2.234375 0.75 L 9.859375 0 L 7.625 7.328125 Z M 12.5 -8.609375 L 10.25 -1.296875 L 2.640625 -0.53125 Z M 12.5 -8.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph44-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.890625 3.3125 C 8.5625 4.40625 7.15625 5.1875 5.71875 3.4375 C 4.90625 2.453125 5.140625 1.5 5.875 0.90625 C 6.828125 0.109375 7.859375 0.3125 9.21875 1.984375 C 9.515625 2.34375 9.96875 2.890625 10.140625 3.109375 Z M 14.609375 3.96875 C 16.96875 2.03125 16.84375 -0.265625 14.640625 -2.984375 C 12.1875 -6.03125 9.859375 -5.984375 7.9375 -4.671875 L 10.09375 -2.03125 C 10.9375 -2.484375 11.625 -2.640625 12.59375 -1.46875 C 13.640625 -0.1875 13.15625 0.625 12.4375 1.21875 L 11.8125 1.734375 C 11.546875 1.40625 11.046875 0.8125 10.65625 0.328125 C 8.25 -2.609375 5.71875 -3.609375 3.4375 -1.734375 C 1.890625 -0.46875 1.125 1.859375 3.109375 4.265625 C 4.546875 6.03125 5.75 6.171875 6.609375 6.09375 C 6.359375 6.3125 5.875 6.78125 5.75 7.015625 L 7.921875 9.671875 C 8.109375 9.421875 9.4375 8.203125 10.390625 7.421875 Z M 14.609375 3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph45-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 8.78125 8.90625 L 21.25 -3.375 L 12.46875 -12.28125 Z M 11.421875 -2.484375 L 12.984375 -9.984375 L 18.953125 -3.921875 Z M 11.140625 -1.15625 L 18.65625 -2.59375 L 9.578125 6.34375 Z M 2.296875 0.546875 L 9.828125 -0.90625 L 8.265625 6.609375 Z M 11.640625 -9.71875 L 10.09375 -2.21875 L 2.5625 -0.78125 Z M 11.640625 -9.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph45-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.265625 -2.203125 C 1.828125 -0.390625 1.625 2.078125 4.375 4.859375 C 7.15625 7.6875 9.6875 7.484375 11.203125 5.984375 C 12.5625 4.65625 13.1875 3.203125 10.875 -0.59375 C 9.75 -2.453125 9.6875 -2.953125 10.125 -3.390625 C 10.5625 -3.8125 11.203125 -3.921875 12.046875 -3.0625 C 13.21875 -1.859375 12.796875 -0.984375 12.515625 -0.578125 L 14.921875 1.859375 C 16.078125 0.53125 16.6875 -1.921875 13.921875 -4.703125 C 11.203125 -7.484375 8.8125 -7.03125 7.453125 -5.703125 C 6.140625 -4.421875 5.703125 -3 7.9375 0.703125 C 8.890625 2.359375 9.0625 3 8.484375 3.5625 C 7.921875 4.109375 7.234375 4.109375 6.328125 3.1875 C 5.375 2.21875 5.1875 1.203125 5.75 0.3125 Z M 3.265625 -2.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph46-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 9.4375 8.203125 L 20.921875 -5 L 11.484375 -13.203125 Z M 11.203125 -3.359375 L 12.171875 -10.953125 L 18.578125 -5.375 Z M 11.015625 -2.015625 L 18.40625 -4.03125 L 10.046875 5.578125 Z M 2.328125 0.375 L 9.71875 -1.65625 L 8.734375 5.953125 Z M 10.859375 -10.59375 L 9.890625 -3 L 2.5 -0.984375 Z M 10.859375 -10.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph46-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.75 -9.53125 L 6.96875 -7.5 L 8.453125 -6.1875 L 4 -1.046875 C 2.515625 0.640625 2.28125 2.203125 4.1875 3.859375 C 4.734375 4.34375 5.484375 4.984375 6.140625 5.28125 L 7.765625 3.40625 C 7.53125 3.28125 7.265625 3.046875 7.125 2.921875 C 6.3125 2.21875 6.359375 1.71875 6.984375 0.984375 L 11.171875 -3.828125 L 13.078125 -2.171875 L 14.859375 -4.203125 L 12.953125 -5.859375 L 15.25 -8.5 L 12.53125 -10.859375 L 10.234375 -8.21875 Z M 8.75 -9.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph47-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 9.90625 7.625 L 20.578125 -6.234375 L 10.671875 -13.859375 Z M 10.984375 -4.015625 L 11.5 -11.65625 L 18.234375 -6.46875 Z M 10.890625 -2.671875 L 18.140625 -5.125 L 10.359375 4.984375 Z M 2.34375 0.234375 L 9.609375 -2.234375 L 9.078125 5.421875 Z M 10.21875 -11.21875 L 9.703125 -3.578125 L 2.4375 -1.109375 Z M 10.21875 -11.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph47-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.484375 3.453125 L 10.71875 -4.640625 L 12.515625 -3.265625 L 14.171875 -5.40625 L 12.375 -6.78125 L 12.90625 -7.484375 C 13.75 -8.5625 14.296875 -8.65625 15.125 -8.015625 C 15.375 -7.828125 15.5625 -7.625 15.6875 -7.46875 L 17.421875 -9.703125 C 17.21875 -9.984375 16.65625 -10.484375 16.1875 -10.84375 C 13.96875 -12.546875 11.84375 -11.984375 10.234375 -9.890625 L 9.53125 -8.96875 L 8.046875 -10.109375 L 6.390625 -7.96875 L 7.875 -6.828125 L 1.640625 1.265625 Z M 4.484375 3.453125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph48-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 10.453125 6.84375 L 20.03125 -7.796875 L 9.578125 -14.640625 Z M 10.640625 -4.84375 L 10.5625 -12.5 L 17.671875 -7.84375 Z M 10.65625 -3.5 L 17.703125 -6.5 L 10.71875 4.171875 Z M 2.359375 0.046875 L 9.40625 -2.953125 L 9.46875 4.703125 Z M 9.328125 -11.96875 L 9.40625 -4.3125 L 2.34375 -1.296875 Z M 9.328125 -11.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph48-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.984375 2.328125 C 14.21875 2.078125 14.375 1.828125 14.625 1.46875 C 16.390625 -1.25 16.890625 -4.75 13.15625 -7.1875 C 9.671875 -9.46875 6.359375 -8.171875 4.140625 -4.78125 C 2.28125 -1.9375 2.109375 1.734375 5.65625 4.0625 C 9.078125 6.28125 11.640625 4.875 12.921875 3.8125 L 9.90625 1.84375 C 9.171875 2.3125 8.515625 2.578125 7.265625 1.765625 C 5.765625 0.78125 5.953125 -0.96875 6.84375 -2.328125 Z M 8.125 -4.125 C 9.09375 -5.359375 10.3125 -6.015625 11.765625 -5.0625 C 13.234375 -4.109375 13.046875 -2.71875 12.234375 -1.4375 Z M 8.125 -4.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph49-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 11.078125 5.78125 L 19.1875 -9.734375 L 8.109375 -15.515625 Z M 10.125 -5.859375 L 9.28125 -13.484375 L 16.828125 -9.546875 Z M 10.25 -4.515625 L 16.96875 -8.203125 L 11.0625 3.09375 Z M 2.34375 -0.1875 L 9.078125 -3.875 L 9.890625 3.75 Z M 8.109375 -12.828125 L 8.921875 -5.203125 L 2.203125 -1.53125 Z M 8.109375 -12.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph49-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.140625 0.9375 C 14.34375 0.671875 14.484375 0.40625 14.6875 0.015625 C 16.1875 -2.859375 16.34375 -6.375 12.40625 -8.4375 C 8.71875 -10.359375 5.53125 -8.765625 3.65625 -5.171875 C 2.078125 -2.15625 2.25 1.515625 6.015625 3.484375 C 9.640625 5.375 12.078125 3.71875 13.234375 2.53125 L 10.03125 0.859375 C 9.375 1.390625 8.71875 1.734375 7.40625 1.046875 C 5.8125 0.21875 5.84375 -1.546875 6.59375 -3 Z M 7.671875 -4.921875 C 8.53125 -6.234375 9.671875 -6.984375 11.21875 -6.171875 C 12.765625 -5.359375 12.703125 -3.984375 12.03125 -2.640625 Z M 7.671875 -4.921875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph50-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 11.609375 4.625 L 18.09375 -11.625 L 6.484375 -16.25 Z M 9.46875 -6.859375 L 7.875 -14.359375 L 15.765625 -11.203125 Z M 9.734375 -5.53125 L 16.046875 -9.875 L 11.328125 1.96875 Z M 2.328125 -0.421875 L 8.640625 -4.765625 L 10.21875 2.734375 Z M 6.75 -13.578125 L 8.34375 -6.09375 L 2.03125 -1.734375 Z M 6.75 -13.578125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph50-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.671875 -6.875 C 12.859375 -6.015625 12.515625 -4.34375 11.703125 -2.296875 C 11.015625 -0.546875 10 1.25 7.703125 0.34375 C 6.078125 -0.3125 5.671875 -1.953125 6.609375 -4.3125 C 7.515625 -6.578125 8.9375 -7.578125 10.671875 -6.875 Z M 15.921875 -13.265625 L 13.609375 -7.484375 C 13.5625 -8.140625 12.875 -9.09375 11.15625 -9.78125 C 7.75 -11.140625 4.609375 -9.28125 3.125 -5.578125 C 1.640625 -1.84375 2.640625 1.375 5.671875 2.578125 C 7.46875 3.296875 8.71875 3.109375 9.671875 2.40625 C 9.59375 2.703125 9.40625 3.34375 9.328125 3.71875 L 12.546875 5 C 12.953125 3.890625 13.390625 2.78125 13.828125 1.6875 L 19.265625 -11.9375 Z M 15.921875 -13.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph51-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 11.9375 3.703125 L 17.125 -13.015625 L 5.1875 -16.71875 Z M 8.890625 -7.59375 L 6.71875 -14.921875 L 14.84375 -12.40625 Z M 9.28125 -6.28125 L 15.234375 -11.125 L 11.453125 1.0625 Z M 2.28125 -0.59375 L 8.21875 -5.4375 L 10.40625 1.921875 Z M 5.671875 -14.078125 L 7.84375 -6.734375 L 1.890625 -1.890625 Z M 5.671875 -14.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph51-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0.46875 L 4.9375 1.53125 L 8.765625 -10.8125 L 5.34375 -11.875 Z M 5.96875 -13.90625 L 9.390625 -12.84375 L 10.328125 -15.875 L 6.90625 -16.9375 Z M 5.96875 -13.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph52-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.1875 2.765625 L 16.046875 -14.296875 L 3.859375 -17.0625 Z M 8.265625 -8.25 L 5.53125 -15.40625 L 13.8125 -13.53125 Z M 8.765625 -6.984375 L 14.3125 -12.265625 L 11.5 0.171875 Z M 2.234375 -0.78125 L 7.78125 -6.0625 L 10.515625 1.09375 Z M 4.5625 -14.46875 L 7.296875 -7.3125 L 1.75 -2.03125 Z M 4.5625 -14.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph52-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.578125 0.359375 L 5.078125 1.140625 L 6.671875 -5.890625 C 7.171875 -8.09375 8.203125 -8.734375 9.6875 -8.40625 C 11.234375 -8.046875 11.46875 -6.921875 11.15625 -5.515625 L 9.421875 2.125 L 12.921875 2.921875 L 14.734375 -5.09375 C 15.453125 -8.265625 14.1875 -10.34375 11.65625 -10.921875 C 9.453125 -11.40625 8.1875 -10.546875 7.5625 -9.859375 C 7.625 -10.28125 7.78125 -11.15625 7.796875 -11.484375 L 4.390625 -12.25 C 4.21875 -11.3125 3.953125 -10.15625 3.71875 -9.078125 Z M 1.578125 0.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph53-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.40625 1.484375 L 14.484375 -15.890625 L 2.078125 -17.375 Z M 7.375 -9.046875 L 3.921875 -15.90625 L 12.359375 -14.890625 Z M 8 -7.859375 L 12.96875 -13.671875 L 11.453125 -1.015625 Z M 2.140625 -1 L 7.109375 -6.828125 L 10.578125 0.015625 Z M 3.03125 -14.859375 L 6.5 -8.03125 L 1.515625 -2.203125 Z M 3.03125 -14.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph53-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.375 -7.5625 C 14.53125 -8.78125 14.6875 -10.109375 14.84375 -11.234375 L 11.453125 -11.640625 C 11.40625 -11.4375 11.21875 -10.671875 11.15625 -10.328125 C 11.0625 -10.921875 10.265625 -12.078125 8.0625 -12.34375 C 4.84375 -12.734375 2.09375 -10.28125 1.609375 -6.28125 C 1.1875 -2.8125 2.796875 0.171875 6.1875 0.578125 C 8.078125 0.8125 9.203125 0.25 10.015625 -0.765625 C 10.015625 -0.765625 9.9375 -0.15625 9.9375 -0.15625 C 9.640625 2.359375 9.046875 3.734375 6.734375 3.453125 C 5.359375 3.296875 4.78125 2.578125 4.625 1.6875 L 1 1.25 C 0.953125 2.71875 1.5625 5.453125 6.25 6.015625 C 11.125 6.59375 12.96875 4.171875 13.46875 0.03125 Z M 8.515625 -9.390625 C 10.765625 -9.125 10.953125 -7.625 10.6875 -5.4375 C 10.4375 -3.3125 9.703125 -1.890625 7.5625 -2.15625 C 5.96875 -2.34375 5.03125 -3.765625 5.296875 -5.984375 C 5.609375 -8.546875 6.9375 -9.578125 8.515625 -9.390625 Z M 8.515625 -9.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph54-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.484375 0.5625 L 13.265625 -16.921875 L 0.78125 -17.484375 Z M 6.6875 -9.578125 L 2.71875 -16.140625 L 11.203125 -15.765625 Z M 7.390625 -8.421875 L 11.90625 -14.609375 L 11.34375 -1.875 Z M 2.0625 -1.15625 L 6.59375 -7.34375 L 10.546875 -0.78125 Z M 1.921875 -15.046875 L 5.890625 -8.484375 L 1.359375 -2.3125 Z M 1.921875 -15.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph54-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph55-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.484375 -0.640625 L 11.578125 -18.109375 L -0.90625 -17.46875 Z M 5.71875 -10.1875 L 1.15625 -16.34375 L 9.640625 -16.78125 Z M 6.53125 -9.09375 L 10.453125 -15.6875 L 11.109375 -2.953125 Z M 1.9375 -1.359375 L 5.84375 -7.9375 L 10.421875 -1.796875 Z M 0.46875 -15.171875 L 5.046875 -9.015625 L 1.125 -2.4375 Z M 0.46875 -15.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph55-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 16.453125 -0.84375 L 20.046875 -1.03125 L 19.15625 -18.234375 L 13.8125 -17.96875 C 12.625 -13.46875 11.046875 -7.359375 10.71875 -5.0625 L 10.703125 -5.0625 C 10.078125 -7.609375 8.25 -13.15625 6.6875 -17.59375 L 1.15625 -17.3125 L 2.046875 -0.109375 L 5.453125 -0.28125 L 5.140625 -6.421875 C 4.984375 -9.390625 4.71875 -12.9375 4.46875 -14.921875 L 4.578125 -14.9375 C 5.5 -11.546875 7.609375 -5.109375 9.109375 -0.46875 L 12.28125 -0.640625 C 13.65625 -6.09375 15.078125 -11.921875 15.734375 -15.484375 L 15.828125 -15.5 C 15.859375 -13.546875 15.96875 -10.234375 16.125 -7.28125 Z M 16.453125 -0.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph56-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.3125 -2.15625 L 9.296875 -19.390625 L -3.015625 -17.234375 Z M 4.453125 -10.796875 L -0.84375 -16.34375 L 7.53125 -17.8125 Z M 5.375 -9.828125 L 8.46875 -16.828125 L 10.671875 -4.28125 Z M 1.75 -1.578125 L 4.84375 -8.59375 L 10.125 -3.046875 Z M -1.375 -15.109375 L 3.90625 -9.578125 L 0.828125 -2.5625 Z M -1.375 -15.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph56-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.984375 -14.296875 C 0.921875 -13.578125 -0.96875 -10.390625 -0.28125 -6.46875 C 0.390625 -2.65625 3.171875 -0.25 7.140625 -0.953125 C 11.171875 -1.65625 12.96875 -4.90625 12.296875 -8.734375 C 11.59375 -12.75 8.71875 -14.953125 4.984375 -14.296875 Z M 3.296875 -7.125 C 2.8125 -9.828125 3.671875 -11.21875 5.3125 -11.515625 C 7.0625 -11.828125 8.265625 -10.75 8.734375 -8.0625 C 9.15625 -5.640625 8.453125 -4.03125 6.734375 -3.71875 C 5.03125 -3.421875 3.71875 -4.671875 3.296875 -7.125 Z M 3.296875 -7.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph57-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 12.015625 -3.421875 L 7.21875 -20.25 L -4.796875 -16.828125 Z M 3.3125 -11.21875 L -2.53125 -16.171875 L 5.640625 -18.5 Z M 4.34375 -10.34375 L 6.671875 -17.625 L 10.15625 -5.359375 Z M 1.578125 -1.75 L 3.921875 -9.046875 L 9.75 -4.078125 Z M -2.9375 -14.890625 L 2.90625 -9.921875 L 0.546875 -2.625 Z M -2.9375 -14.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph57-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.265625 -11.96875 C 6.515625 -12.609375 7.265625 -11.09375 7.875 -8.96875 C 8.390625 -7.171875 8.671875 -5.125 6.296875 -4.453125 C 4.609375 -3.96875 3.296875 -5.015625 2.609375 -7.453125 C 1.9375 -9.8125 2.46875 -11.453125 4.265625 -11.96875 Z M 4.515625 -20.21875 L 6.21875 -14.25 C 5.796875 -14.71875 4.640625 -15.078125 2.859375 -14.5625 C -0.671875 -13.5625 -2.015625 -10.171875 -0.921875 -6.328125 C 0.171875 -2.46875 2.921875 -0.53125 6.0625 -1.421875 C 7.921875 -1.953125 8.796875 -2.84375 9.125 -4 C 9.25 -3.71875 9.484375 -3.09375 9.65625 -2.75 L 12.984375 -3.703125 C 12.625 -4.8125 12.296875 -5.96875 11.984375 -7.09375 L 7.96875 -21.203125 Z M 4.515625 -20.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph58-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 11.609375 -4.609375 L 5.140625 -20.875 L -6.46875 -16.265625 Z M 2.171875 -11.484375 L -4.140625 -15.828125 L 3.75 -18.96875 Z M 3.265625 -10.703125 L 4.859375 -18.21875 L 9.578125 -6.359375 Z M 1.390625 -1.890625 L 3 -9.390625 L 9.28125 -5.03125 Z M -4.4375 -14.53125 L 1.875 -10.15625 L 0.28125 -2.671875 Z M -4.4375 -14.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph58-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.9375 -10.09375 C 9.875 -10.4375 9.765625 -10.703125 9.609375 -11.109375 C 8.40625 -14.140625 5.84375 -16.546875 1.703125 -14.890625 C -2.15625 -13.359375 -3.03125 -9.90625 -1.53125 -6.15625 C -0.28125 -2.984375 2.625 -0.71875 6.578125 -2.28125 C 10.359375 -3.796875 10.703125 -6.734375 10.5625 -8.359375 L 7.203125 -7.03125 C 7.171875 -6.1875 7 -5.484375 5.625 -4.9375 C 3.953125 -4.265625 2.640625 -5.4375 2.03125 -6.9375 Z M 1.28125 -9.015625 C 0.84375 -10.515625 1.03125 -11.890625 2.640625 -12.53125 C 4.265625 -13.1875 5.28125 -12.21875 5.859375 -10.828125 Z M 1.28125 -9.015625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph59-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 11.234375 -5.46875 L 3.578125 -21.203125 L -7.65625 -15.734375 Z M 1.296875 -11.609375 L -5.3125 -15.484375 L 2.328125 -19.203125 Z M 2.46875 -10.921875 L 3.484375 -18.515625 L 9.0625 -7.0625 Z M 1.25 -2 L 2.28125 -9.59375 L 8.890625 -5.71875 Z M -5.5 -14.140625 L 1.109375 -10.265625 L 0.078125 -2.6875 Z M -5.5 -14.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph59-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 -2.265625 L -3.328125 -18.640625 L -6.546875 -17.078125 L 1.4375 -0.703125 Z M 4.65625 -2.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph60-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 10.953125 -6.03125 L 2.515625 -21.359375 L -8.4375 -15.328125 Z M 0.703125 -11.671875 L -6.09375 -15.203125 L 1.359375 -19.296875 Z M 1.90625 -11.03125 L 2.5625 -18.671875 L 8.71875 -7.5 Z M 1.140625 -2.0625 L 1.796875 -9.6875 L 8.59375 -6.15625 Z M -6.203125 -13.859375 L 0.59375 -10.3125 L -0.046875 -2.6875 Z M -6.203125 -13.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph60-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph61-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 10.390625 -6.953125 L 0.65625 -21.5 L -9.734375 -14.546875 Z M -0.3125 -11.6875 L -7.390625 -14.609375 L -0.328125 -19.34375 Z M 0.9375 -11.15625 L 0.921875 -18.828125 L 8.015625 -8.234375 Z M 0.953125 -2.140625 L 0.9375 -9.8125 L 8.015625 -6.875 Z M -7.390625 -13.265625 L -0.3125 -10.328125 L -0.296875 -2.671875 Z M -7.390625 -13.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph61-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -7.875 -15.453125 L 1.703125 -1.140625 L 4.796875 -3.21875 L 0.65625 -9.40625 L 6.421875 -13.25 L 10.5625 -7.0625 L 13.640625 -9.140625 L 4.0625 -23.453125 L 0.984375 -21.375 L 4.71875 -15.78125 L -1.046875 -11.9375 L -4.78125 -17.53125 Z M -7.875 -15.453125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph62-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 9.5625 -8.0625 L -1.71875 -21.4375 L -11.28125 -13.375 Z M -1.578125 -11.578125 L -8.9375 -13.71875 L -2.4375 -19.1875 Z M -0.296875 -11.203125 L -1.15625 -18.8125 L 7.0625 -9.0625 Z M 0.71875 -2.25 L -0.140625 -9.859375 L 7.21875 -7.71875 Z M -8.796875 -12.375 L -1.4375 -10.234375 L -0.578125 -2.625 Z M -8.796875 -12.375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph62-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.875 -14.859375 C -6.03125 -12.203125 -6.0625 -8.5 -3.5 -5.453125 C -1 -2.5 2.609375 -1.8125 5.6875 -4.40625 C 8.828125 -7.046875 8.765625 -10.75 6.25 -13.71875 C 3.625 -16.84375 0.03125 -17.3125 -2.875 -14.859375 Z M -0.734375 -7.8125 C -2.515625 -9.90625 -2.484375 -11.546875 -1.203125 -12.625 C 0.15625 -13.765625 1.734375 -13.453125 3.5 -11.359375 C 5.078125 -9.484375 5.296875 -7.734375 3.953125 -6.59375 C 2.625 -5.484375 0.859375 -5.90625 -0.734375 -7.8125 Z M -0.734375 -7.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph63-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 8.75 -8.9375 L -3.75 -21.1875 L -12.5 -12.25 Z M -2.6875 -11.375 L -10.203125 -12.796875 L -4.265625 -18.875 Z M -1.359375 -11.125 L -2.9375 -18.609375 L 6.171875 -9.6875 Z M 0.515625 -2.296875 L -1.078125 -9.796875 L 6.453125 -8.375 Z M -9.9375 -11.46875 L -2.40625 -10.0625 L -0.828125 -2.546875 Z M -9.9375 -11.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph63-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.265625 -3.21875 C -0.421875 -1.828125 2.0625 -1.671875 4.796875 -4.46875 C 7.5625 -7.296875 7.296875 -9.828125 5.78125 -11.3125 C 4.4375 -12.640625 2.953125 -13.234375 -0.796875 -10.84375 C -2.625 -9.703125 -3.109375 -9.640625 -3.5625 -10.078125 C -4 -10.5 -4.109375 -11.125 -3.265625 -11.984375 C -2.09375 -13.1875 -1.203125 -12.78125 -0.8125 -12.515625 L 1.578125 -14.953125 C 0.25 -16.09375 -2.21875 -16.640625 -4.953125 -13.84375 C -7.6875 -11.0625 -7.1875 -8.6875 -5.828125 -7.34375 C -4.53125 -6.0625 -3.09375 -5.65625 0.5625 -7.953125 C 2.203125 -8.921875 2.84375 -9.109375 3.4375 -8.546875 C 3.984375 -8 3.96875 -7.3125 3.0625 -6.390625 C 2.109375 -5.40625 1.109375 -5.203125 0.203125 -5.734375 Z M -2.265625 -3.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph64-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 7.84375 -9.734375 L -5.78125 -20.71875 L -13.625 -10.984375 Z M -3.765625 -11.0625 L -11.390625 -11.765625 L -6.046875 -18.375 Z M -2.421875 -10.953125 L -4.703125 -18.25 L 5.21875 -10.234375 Z M 0.28125 -2.34375 L -2.015625 -9.640625 L 5.625 -8.953125 Z M -10.984375 -10.46875 L -3.359375 -9.78125 L -1.0625 -2.453125 Z M -10.984375 -10.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph64-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.515625 -6.375 C 7.5 -8.828125 7.109375 -12.34375 3.5625 -15.203125 C 0.4375 -17.734375 -2.859375 -17.5 -4.6875 -15.234375 C -5.96875 -13.640625 -5.96875 -12.15625 -5.578125 -11.125 C -5.953125 -11.421875 -6.59375 -11.859375 -6.890625 -12.03125 L -9.078125 -9.34375 C -8.265625 -8.703125 -7.4375 -8.046875 -6.625 -7.390625 L 4.875 1.890625 L 7.109375 -0.890625 L 2.359375 -4.71875 C 3.25 -4.640625 4.375 -4.9375 5.515625 -6.375 Z M 2.8125 -7.53125 C 1.59375 -6.015625 0.0625 -6.40625 -1.859375 -7.96875 C -3.890625 -9.609375 -4.4375 -10.96875 -3.15625 -12.5625 C -2.109375 -13.875 -0.46875 -13.8125 1.375 -12.3125 C 3.453125 -10.65625 4.015625 -9.015625 2.8125 -7.53125 Z M 2.8125 -7.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph65-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 7.078125 -10.3125 L -7.359375 -20.21875 L -14.4375 -9.90625 Z M -4.609375 -10.75 L -12.28125 -10.84375 L -7.46875 -17.84375 Z M -3.265625 -10.71875 L -6.109375 -17.84375 L 4.40625 -10.625 Z M 0.09375 -2.359375 L -2.75 -9.46875 L 4.90625 -9.359375 Z M -11.765625 -9.59375 L -4.109375 -9.484375 L -1.25 -2.375 Z M -11.765625 -9.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph65-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.90625 -1.3125 L 2.921875 -4.265625 L -7.734375 -11.578125 L -9.75 -8.625 Z M -11.5 -9.828125 L -9.484375 -12.78125 L -12.09375 -14.578125 L -14.109375 -11.625 Z M -11.5 -9.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph66-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 6.4375 -10.703125 L -8.5625 -19.71875 L -15 -9.015625 Z M -5.25 -10.453125 L -12.890625 -10.09375 L -8.515625 -17.375 Z M -3.890625 -10.515625 L -7.15625 -17.4375 L 3.765625 -10.859375 Z M -0.046875 -2.359375 L -3.3125 -9.296875 L 4.328125 -9.640625 Z M -12.3125 -8.875 L -4.671875 -9.234375 L -1.390625 -2.296875 Z M -12.3125 -8.875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph66-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -10.90625 -6.953125 L -8.578125 -5.5625 L -7.546875 -7.265625 L -1.734375 -3.765625 C 0.203125 -2.609375 1.78125 -2.625 3.078125 -4.796875 C 3.453125 -5.40625 3.953125 -6.25 4.125 -6.96875 L 2 -8.25 C 1.921875 -7.96875 1.734375 -7.671875 1.640625 -7.5 C 1.09375 -6.59375 0.578125 -6.5625 -0.25 -7.0625 L -5.703125 -10.34375 L -4.390625 -12.515625 L -6.71875 -13.90625 L -8.03125 -11.734375 L -11.03125 -13.546875 L -12.875 -10.46875 L -9.875 -8.65625 Z M -10.90625 -6.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph67-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 5.546875 -11.203125 L -10.125 -18.984375 L -15.671875 -7.78125 Z M -6.0625 -9.984375 L -13.671875 -9.015625 L -9.890625 -16.625 Z M -4.734375 -10.15625 L -8.546875 -16.796875 L 2.875 -11.140625 Z M -0.234375 -2.359375 L -4.046875 -8.984375 L 3.546875 -9.96875 Z M -12.984375 -7.84375 L -5.40625 -8.8125 L -1.5625 -2.1875 Z M -12.984375 -7.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph67-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.046875 -10.375 C 0.5 -9.609375 1.78125 -8.65625 0.78125 -6.625 C 0.203125 -5.484375 -0.75 -5.3125 -1.59375 -5.734375 C -2.703125 -6.28125 -2.953125 -7.28125 -1.984375 -9.21875 C -1.78125 -9.640625 -1.46875 -10.265625 -1.34375 -10.515625 Z M -2.375 -14.953125 C -5.125 -16.3125 -7.1875 -15.21875 -8.75 -12.125 C -10.515625 -8.625 -9.5 -6.515625 -7.515625 -5.328125 L -6 -8.375 C -6.765625 -8.9375 -7.1875 -9.5 -6.515625 -10.859375 C -5.78125 -12.34375 -4.84375 -12.25 -4 -11.828125 L -3.28125 -11.484375 C -3.46875 -11.109375 -3.8125 -10.40625 -4.09375 -9.84375 C -5.78125 -6.453125 -5.625 -3.71875 -2.984375 -2.40625 C -1.1875 -1.515625 1.21875 -1.8125 2.609375 -4.609375 C 3.625 -6.640625 3.265625 -7.78125 2.828125 -8.546875 C 3.125 -8.390625 3.765625 -8.140625 4.03125 -8.125 L 5.546875 -11.203125 C 5.25 -11.25 3.609375 -11.984375 2.5 -12.53125 Z M -2.375 -14.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph68-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 L 4.703125 -11.578125 L -11.515625 -18.15625 L -16.21875 -6.578125 Z M -6.8125 -9.515625 L -14.3125 -7.96875 L -11.109375 -15.84375 Z M -5.484375 -9.78125 L -9.78125 -16.109375 L 2.03125 -11.3125 Z M -0.40625 -2.328125 L -4.71875 -8.65625 L 2.796875 -10.203125 Z M -13.546875 -6.84375 L -6.046875 -8.390625 L -1.734375 -2.046875 Z M -13.546875 -6.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph68-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.9375 -4.796875 L -14.9375 -11.640625 L -16.28125 -8.328125 L 0.59375 -1.484375 Z M 1.9375 -4.796875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(50.193787%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3711.171875 1860.575 C 3711.171875 838.54375 2882.65625 9.989062 1860.585938 9.989062 C 838.515625 9.989062 10 838.54375 10 1860.575 C 10 2882.645312 838.515625 3711.160937 1860.585938 3711.160937 C 2882.65625 3711.160937 3711.171875 2882.645312 3711.171875 1860.575 Z M 3711.171875 1860.575 ",
    transform: "matrix(0.1,0,0,-0.1,0,372.12)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.041992%,32.542419%,58.396912%)",
      fillOpacity: 1
    },
    d: "M 21.953125 221.203125 L 29.988281 221.203125 L 29.988281 195.316406 L 21.953125 195.316406 Z M 21.953125 221.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.041992%,32.542419%,58.396912%)",
      fillOpacity: 1
    },
    d: "M 13.03125 212.277344 L 38.914063 212.277344 L 38.914063 204.242188 L 13.03125 204.242188 Z M 13.03125 212.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.041992%,32.542419%,58.396912%)",
      fillOpacity: 1
    },
    d: "M 337.953125 221.203125 L 345.988281 221.203125 L 345.988281 195.316406 L 337.953125 195.316406 Z M 337.953125 221.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.041992%,32.542419%,58.396912%)",
      fillOpacity: 1
    },
    d: "M 329.027344 212.277344 L 354.914063 212.277344 L 354.914063 204.242188 L 329.027344 204.242188 Z M 329.027344 212.277344 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 37.1574,
    y: 174.185
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 37.7336,
    y: 165.541
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 40.2242,
    y: 150.756
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 42.3605,
    y: 140.074
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 53.1848,
    y: 114.64
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 52.9188,
    y: 114.714
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-1",
    x: 60.7516,
    y: 101.513
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-1",
    x: 60.4836,
    y: 101.565
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-1",
    x: 69.132,
    y: 89.422
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph9-1",
    x: 80.4992,
    y: 76.802
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph10-1",
    x: 91.1516,
    y: 67.134
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph11-1",
    x: 102.684,
    y: 58.517
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph12-1",
    x: 115.749,
    y: 50.884
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph12-2",
    x: 115.749,
    y: 50.884
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph13-1",
    x: 115.565,
    y: 50.86
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph14-1",
    x: 125.531,
    y: 46.033
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph15-1",
    x: 133.671,
    y: 42.574
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph16-1",
    x: 148.139,
    y: 38.21
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph17-1",
    x: 147.882,
    y: 38.047
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph18-1",
    x: 163.405,
    y: 34.857
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph19-1",
    x: 179.259,
    y: 33.509
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph20-1",
    x: 190.616,
    y: 33.269
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph21-1",
    x: 206.387,
    y: 34.631
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph22-1",
    x: 221.2,
    y: 37.66
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph23-1",
    x: 221.085,
    y: 37.511
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph24-1",
    x: 232.143,
    y: 40.673
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph25-1",
    x: 242.479,
    y: 44.394
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph26-1",
    x: 256.065,
    y: 51.044
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph27-1",
    x: 255.997,
    y: 50.757
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph28-1",
    x: 269.541,
    y: 58.99
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph29-1",
    x: 281.637,
    y: 68.432
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph30-1",
    x: 281.623,
    y: 68.165
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph31-1",
    x: 292.551,
    y: 78.337
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph32-1",
    x: 302.44,
    y: 89.542
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph33-1",
    x: 311.549,
    y: 102.74
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph34-1",
    x: 311.555,
    y: 102.531
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph35-1",
    x: 317.371,
    y: 112.317
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph36-1",
    x: 323.922,
    y: 126.956
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph37-1",
    x: 324.051,
    y: 126.679
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph38-1",
    x: 329.179,
    y: 141.628
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph39-1",
    x: 332.807,
    y: 158.199
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph40-1",
    x: 334.289,
    y: 174.144
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph41-1",
    x: 24.552,
    y: 243.286
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph42-1",
    x: 32.5855,
    y: 260.849
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph43-1",
    x: 38.491,
    y: 271.452
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph44-1",
    x: 47.7883,
    y: 285.1149
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph45-1",
    x: 58.2691,
    y: 297.6989
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph46-1",
    x: 69.0363,
    y: 308.3934
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph47-1",
    x: 77.1086,
    y: 315.3356
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph48-1",
    x: 85.3449,
    y: 321.7098
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph49-1",
    x: 99.4617,
    y: 330.7751
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph50-1",
    x: 114.425,
    y: 338.4548
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph51-1",
    x: 130.773,
    y: 344.6923
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph52-1",
    x: 139.616,
    y: 347.4958
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph53-1",
    x: 156.769,
    y: 351.2341
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph54-1",
    x: 174.042,
    y: 353.0446
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph55-1",
    x: 182.725,
    y: 353.6923
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph56-1",
    x: 207.452,
    y: 352.0223
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph57-1",
    x: 224.55,
    y: 348.8856
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph58-1",
    x: 241.585,
    y: 343.8641
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph59-1",
    x: 256.646,
    y: 337.6376
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph60-1",
    x: 264.677,
    y: 333.6559
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph61-1",
    x: 272.295,
    y: 329.6395
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph62-1",
    x: 289.619,
    y: 317.7372
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph63-1",
    x: 302.695,
    y: 306.4899
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph64-1",
    x: 313.501,
    y: 295.3415
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph65-1",
    x: 324.225,
    y: 281.6473
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph66-1",
    x: 329.337,
    y: 274.1337
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph67-1",
    x: 335.238,
    y: 264.332
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(50.193787%,0%,0%)",
      fillOpacity: 1
    }
  }, _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph68-1",
    x: 342.313,
    y: 249.564
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(50.193787%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3161.796875 1900.575 C 3161.796875 1351.082812 2823.710938 880.496875 2344.335938 685.535937 C 2336.015625 682.254687 2327.578125 678.817187 2319.101563 675.653125 C 2173.632813 619.910937 2015.742188 589.403125 1850.585938 589.403125 C 1534.492188 589.403125 1244.375 701.317187 1018.007813 887.840625 C 988.710938 911.785937 960.507813 937.1375 933.515625 963.54375 C 690.390625 1201.434375 539.414063 1533.348437 539.414063 1900.575 C 539.414063 2304.79375 722.304688 2666.35625 1009.882813 2906.746875 C 1035.664063 2928.348437 1062.226563 2948.973437 1089.6875 2968.504687 C 1304.179688 3121.707812 1566.835938 3211.785937 1850.585938 3211.785937 C 2574.765625 3211.785937 3161.796875 2624.754687 3161.796875 1900.575 Z M 3161.796875 1900.575 ",
    transform: "matrix(0.1,0,0,-0.1,0,372.12)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.4375%,36.473083%,65.818787%)",
      fillOpacity: 1
    },
    d: "M 220.378906 276.527344 C 208.367188 277.277344 204.464844 285.066406 204.464844 285.066406 C 192.867188 294.050781 193.378906 293.601563 187.878906 294.582031 C 182.378906 295.554688 176.304688 293.402344 176.304688 293.402344 C 205.632813 293.375 208.816406 265.203125 208.816406 265.203125 C 212.394531 270.308594 221.171875 273.605469 221.171875 273.605469 Z M 272.800781 233.175781 C 263.316406 214.117188 229.113281 198.785156 217.988281 236.335938 C 217.988281 236.335938 207.898438 242.296875 206.78125 248.222656 C 206.675781 248.746094 206.488281 249.175781 206.175781 249.519531 C 202.53125 239.007813 190.164063 233.027344 177.234375 223 C 162.550781 211.589844 151.089844 200.820313 148.605469 197.992188 C 146.121094 195.152344 143.023438 194.234375 147.144531 180.324219 C 147.144531 180.324219 162.882813 190.71875 165.285156 191.636719 C 167.839844 192.597656 171.515625 192.167969 173.832031 186.753906 C 175.511719 182.847656 178.726563 182.597656 180.730469 181.804688 C 182.734375 181.023438 181.28125 179.445313 181.28125 179.445313 C 181.28125 179.445313 183.328125 179.488281 183.945313 177.640625 C 184.539063 175.773438 183.476563 175.113281 184.976563 173.601563 C 187.035156 172.734375 191.011719 172.277344 191.742188 170.460938 C 192.503906 168.65625 188.816406 162.289063 188.882813 159.3125 C 188.933594 156.339844 188.703125 155.328125 193.535156 149.398438 C 198.367188 143.492188 206.070313 130.96875 200.902344 117.527344 C 195.039063 102.246094 176.296875 77.238281 130.382813 91.371094 C 130.351563 91.382813 130.320313 91.402344 130.289063 91.402344 C 130.289063 91.402344 122.421875 84.722656 114.6875 85.433594 C 114.050781 85.539063 113.433594 85.683594 112.839844 85.851563 C 111.617188 86.207031 110.472656 86.6875 109.394531 87.28125 C 107.902344 88.273438 106.503906 89.714844 105.253906 91.726563 C 104.753906 92.519531 104.28125 93.398438 103.84375 94.378906 C 95.523438 112.746094 113.746094 117.632813 113.746094 117.632813 C 113.746094 117.632813 113.726563 117.714844 113.652344 117.882813 C 112.515625 121.136719 98.070313 152.675781 114 167.277344 C 108.851563 195.894531 90.097656 209.714844 94.617188 242.953125 C 96.015625 253.179688 99.347656 270.324219 106.101563 285.320313 C 127.902344 301.96875 155.148438 312.148438 185.21875 312.148438 C 200.925781 312.148438 216.039063 309.445313 229.878906 304.144531 C 230.683594 303.839844 231.441406 303.574219 232.234375 303.261719 C 233.296875 302.582031 234.3125 301.636719 235.386719 300.929688 C 235.523438 300.84375 235.667969 300.753906 235.804688 300.667969 C 235.804688 300.648438 235.824219 300.648438 235.835938 300.648438 C 236.921875 300.136719 237.976563 299.582031 238.996094 299.050781 C 238.996094 299.050781 245.5 295.378906 245.613281 287.007813 C 245.667969 282.894531 243.945313 281.058594 261.070313 271.800781 C 278.175781 262.523438 279.660156 246.941406 272.800781 233.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 138.09375 102.574219 C 138.695313 102.15625 139.316406 101.816406 139.941406 101.550781 C 139.945313 101.347656 139.949219 101.144531 139.941406 100.941406 C 139.820313 96.851563 137.429688 93.609375 134.605469 93.695313 C 131.777344 93.777344 129.585938 97.15625 129.710938 101.246094 C 129.820313 104.949219 131.796875 107.964844 134.269531 108.429688 C 134.414063 106.417969 135.800781 104.160156 138.09375 102.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 141.589844 110.601563 C 142.164063 111.046875 142.675781 111.539063 143.117188 112.054688 C 143.3125 111.996094 143.507813 111.9375 143.703125 111.867188 C 147.5625 110.519531 149.933594 107.265625 149 104.59375 C 148.066406 101.925781 144.183594 100.855469 140.324219 102.203125 C 136.824219 103.429688 134.546875 106.222656 134.851563 108.722656 C 136.8125 108.25 139.382813 108.894531 141.589844 110.601563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 134.507813 116.328125 C 134.222656 117 133.878906 117.617188 133.492188 118.175781 C 133.59375 118.351563 133.703125 118.523438 133.816406 118.695313 C 136.097656 122.085938 139.847656 123.558594 142.195313 121.980469 C 144.539063 120.402344 144.59375 116.375 142.3125 112.980469 C 140.242188 109.90625 136.964844 108.410156 134.621094 109.335938 C 135.574219 111.113281 135.601563 113.765625 134.507813 116.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.144531 111.722656 C 126.417969 111.671875 125.71875 111.550781 125.0625 111.371094 C 124.933594 111.523438 124.804688 111.683594 124.683594 111.847656 C 122.234375 115.121094 122.082031 119.148438 124.34375 120.84375 C 126.609375 122.535156 130.429688 121.257813 132.878906 117.984375 C 135.101563 115.015625 135.429688 111.425781 133.785156 109.519531 C 132.417969 111.007813 129.925781 111.90625 127.144531 111.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.242188 103.308594 C 129.050781 102.601563 128.9375 101.902344 128.894531 101.226563 C 128.703125 101.152344 128.511719 101.085938 128.316406 101.019531 C 124.421875 99.777344 120.566406 100.949219 119.707031 103.640625 C 118.84375 106.335938 121.304688 109.527344 125.195313 110.773438 C 128.730469 111.902344 132.230469 111.039063 133.492188 108.863281 C 131.640625 108.058594 129.972656 105.996094 129.242188 103.308594 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbimage);
export default __webpack_public_path__ + "static/media/cbimage.623d429a7fd6fc94cf7fce1dfd8f0764.svg";
export { ForwardRef as ReactComponent };